/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as LogoutRouteImport } from './routes/logout'
import { Route as LoginRouteImport } from './routes/login'
import { Route as DashboardRouteRouteImport } from './routes/dashboard/route'
import { Route as IndexRouteImport } from './routes/index'
import { Route as DashboardIndexRouteImport } from './routes/dashboard/index'
import { Route as DashboardRiskCheckRouteImport } from './routes/dashboard/risk-check'
import { Route as DashboardPromoterRouteImport } from './routes/dashboard/promoter'
import { Route as DashboardOrdersRouteImport } from './routes/dashboard/orders'
import { Route as DashboardNovoSellRetryRouteImport } from './routes/dashboard/novo-sell-retry'
import { Route as DashboardMerchandiseRouteImport } from './routes/dashboard/merchandise'
import { Route as DashboardFailedOrdersRouteImport } from './routes/dashboard/failed-orders'
import { Route as DashboardCancelOrderRouteImport } from './routes/dashboard/cancel-order'
import { Route as DashboardBulkOperationRouteImport } from './routes/dashboard/bulk-operation'
import { Route as DashboardBannerRouteImport } from './routes/dashboard/banner'
import { Route as DashboardApkManagementRouteImport } from './routes/dashboard/apk-management'
import { Route as DashboardAdminActionRouteImport } from './routes/dashboard/admin-action'
import { Route as DashboardPromotersIndexRouteImport } from './routes/dashboard/promoters/index'
import { Route as DashboardProductIndexRouteImport } from './routes/dashboard/product/index'
import { Route as DashboardMasterControlIndexRouteImport } from './routes/dashboard/master-control/index'
import { Route as DashboardMaintenanceIndexRouteImport } from './routes/dashboard/maintenance/index'
import { Route as DashboardLeaderboardIndexRouteImport } from './routes/dashboard/leaderboard/index'
import { Route as DashboardHorizonIndexRouteImport } from './routes/dashboard/horizon/index'
import { Route as DashboardFantasyIndexRouteImport } from './routes/dashboard/fantasy/index'
import { Route as DashboardCompaniesIndexRouteImport } from './routes/dashboard/companies/index'
import { Route as DashboardCategoryIndexRouteImport } from './routes/dashboard/category/index'
import { Route as DashboardBrandIndexRouteImport } from './routes/dashboard/brand/index'
import { Route as DashboardBannerManagementIndexRouteImport } from './routes/dashboard/banner-management/index'
import { Route as DashboardAdminLogsIndexRouteImport } from './routes/dashboard/admin-logs/index'
import { Route as DashboardAdminApprovalsIndexRouteImport } from './routes/dashboard/admin-approvals/index'
import { Route as DashboardSupportPushNotificationRouteImport } from './routes/dashboard/support/push-notification'
import { Route as DashboardSupportManageUserRouteImport } from './routes/dashboard/support/manage-user'
import { Route as DashboardSupportEscalateIssueRouteImport } from './routes/dashboard/support/escalate-issue'
import { Route as DashboardPromotersPromoterIdRouteImport } from './routes/dashboard/promoters/$promoterId'
import { Route as DashboardProductTrackOrderRouteImport } from './routes/dashboard/product/track-order'
import { Route as DashboardProductManageVoucherRouteImport } from './routes/dashboard/product/manage-voucher'
import { Route as DashboardProductIdRouteImport } from './routes/dashboard/product/$id'
import { Route as DashboardLeaderboardAddRouteImport } from './routes/dashboard/leaderboard/add'
import { Route as DashboardLeaderboardIdRouteImport } from './routes/dashboard/leaderboard/$id'
import { Route as DashboardFantasyPlayersRouteImport } from './routes/dashboard/fantasy/players'
import { Route as DashboardFantasyContestGroupRouteImport } from './routes/dashboard/fantasy/contest-group'
import { Route as DashboardCompaniesAddRouteImport } from './routes/dashboard/companies/add'
import { Route as DashboardCompaniesIdRouteImport } from './routes/dashboard/companies/$id'
import { Route as DashboardBannerManagementNewRouteImport } from './routes/dashboard/banner-management/new'
import { Route as DashboardBannerManagementBannerIdRouteImport } from './routes/dashboard/banner-management/$bannerId'
import { Route as AdminAuthSuccessRouteImport } from './routes/admin/auth/success'
import { Route as DashboardFantasyCreateContestRouteRouteImport } from './routes/dashboard/fantasy/create-contest/route'
import { Route as DashboardPromotersWithdrawRequestIndexRouteImport } from './routes/dashboard/promoters/withdraw-request/index'
import { Route as DashboardPromotersVerificationIndexRouteImport } from './routes/dashboard/promoters/verification/index'
import { Route as DashboardPromotersRequestsIndexRouteImport } from './routes/dashboard/promoters/requests/index'
import { Route as DashboardProductComboIndexRouteImport } from './routes/dashboard/product/combo/index'
import { Route as DashboardProductAddProductIndexRouteImport } from './routes/dashboard/product/add-product/index'
import { Route as DashboardHorizonTopicsIndexRouteImport } from './routes/dashboard/horizon/topics/index'
import { Route as DashboardHorizonEventTemplatesIndexRouteImport } from './routes/dashboard/horizon/event-templates/index'
import { Route as DashboardHorizonCategoriesIndexRouteImport } from './routes/dashboard/horizon/categories/index'
import { Route as DashboardFantasyTeamsIndexRouteImport } from './routes/dashboard/fantasy/teams/index'
import { Route as DashboardFantasyLeagueManagementIndexRouteImport } from './routes/dashboard/fantasy/league-management/index'
import { Route as DashboardFantasyHomeManagementIndexRouteImport } from './routes/dashboard/fantasy/home-management/index'
import { Route as DashboardFantasyFixtureIndexRouteImport } from './routes/dashboard/fantasy/fixture/index'
import { Route as DashboardFantasyCreateContestIndexRouteImport } from './routes/dashboard/fantasy/create-contest/index'
import { Route as DashboardFantasyContestTemplateIndexRouteImport } from './routes/dashboard/fantasy/contest-template/index'
import { Route as DashboardCategoryAddCategoryIndexRouteImport } from './routes/dashboard/category/add-category/index'
import { Route as DashboardBrandAddBrandIndexRouteImport } from './routes/dashboard/brand/add-brand/index'
import { Route as DashboardSupportManageUserTransactionRouteImport } from './routes/dashboard/support/manage-user/transaction'
import { Route as DashboardSupportManageUserOrderHistoryRouteImport } from './routes/dashboard/support/manage-user/order-history'
import { Route as DashboardSupportManageUserGameplayHistoryRouteImport } from './routes/dashboard/support/manage-user/gameplay-history'
import { Route as DashboardSupportManageUserFantasyHistoryRouteImport } from './routes/dashboard/support/manage-user/fantasy-history'
import { Route as DashboardSupportManageUserAviatorHistoryRouteImport } from './routes/dashboard/support/manage-user/aviator-history'
import { Route as DashboardPromotersWithdrawRequestWithdrawalIdRouteImport } from './routes/dashboard/promoters/withdraw-request/$withdrawalId'
import { Route as DashboardPromotersVerificationVerificationIdRouteImport } from './routes/dashboard/promoters/verification/$verificationId'
import { Route as DashboardPromotersRequestsRequestIdRouteImport } from './routes/dashboard/promoters/requests/$requestId'
import { Route as DashboardProductComboIdRouteImport } from './routes/dashboard/product/combo/$id'
import { Route as DashboardLeaderboardCloneIdRouteImport } from './routes/dashboard/leaderboard/clone.$id'
import { Route as DashboardHorizonTopicsIdRouteImport } from './routes/dashboard/horizon/topics/$id'
import { Route as DashboardFantasyLeagueManagementAddTourRouteImport } from './routes/dashboard/fantasy/league-management/add-tour'
import { Route as DashboardFantasyFixtureFixtureTeamManagementRouteImport } from './routes/dashboard/fantasy/fixture/fixture-team-management'
import { Route as DashboardFantasyFixtureContestTemplateDetailsRouteImport } from './routes/dashboard/fantasy/fixture/contest-template-details'
import { Route as DashboardFantasyFixtureContestCategoryRouteImport } from './routes/dashboard/fantasy/fixture/contest-category'
import { Route as DashboardFantasyFixtureChooseFromTemplateRouteImport } from './routes/dashboard/fantasy/fixture/choose-from-template'
import { Route as DashboardFantasyContestTemplateDetailsRouteImport } from './routes/dashboard/fantasy/contest-template/details'
import { Route as DashboardCategoryAddCategoryCategoryImageRouteImport } from './routes/dashboard/category/add-category/category-image'
import { Route as DashboardBrandAddBrandAddBrandPropsRouteImport } from './routes/dashboard/brand/add-brand/add-brand-props'
import { Route as DashboardFantasyFixtureContestWinnerManagementV2RouteRouteImport } from './routes/dashboard/fantasy/fixture/contest-winner-management-v2/route'
import { Route as DashboardFantasyContestTemplateAddTemplateRouteRouteImport } from './routes/dashboard/fantasy/contest-template/add-template/route'
import { Route as DashboardProductComboAddCombinationIndexRouteImport } from './routes/dashboard/product/combo/add-combination/index'
import { Route as DashboardProductAddProductSaleSettingsIndexRouteImport } from './routes/dashboard/product/add-product/sale-settings/index'
import { Route as DashboardHorizonEventTemplatesRequestsIndexRouteImport } from './routes/dashboard/horizon/event-templates/requests/index'
import { Route as DashboardFantasyFixtureContestWinnerManagementIndexRouteImport } from './routes/dashboard/fantasy/fixture/contest-winner-management/index'
import { Route as DashboardFantasyFixtureContestWinnerManagementV2IndexRouteImport } from './routes/dashboard/fantasy/fixture/contest-winner-management-v2/index'
import { Route as DashboardFantasyFixtureContestDetailsIndexRouteImport } from './routes/dashboard/fantasy/fixture/contest-details/index'
import { Route as DashboardFantasyContestTemplateAddTemplateIndexRouteImport } from './routes/dashboard/fantasy/contest-template/add-template/index'
import { Route as DashboardFantasyFixtureContestDetailsUserPlayersRouteImport } from './routes/dashboard/fantasy/fixture/contest-details/user-players'
import { Route as DashboardProductAddProductSaleSettingsProductSettingsIndexRouteImport } from './routes/dashboard/product/add-product/sale-settings/product-settings/index'
import { Route as DashboardProductAddProductSaleSettingsProductSettingsInvoiceDetailsRouteImport } from './routes/dashboard/product/add-product/sale-settings/product-settings/invoice-details'

const LogoutRoute = LogoutRouteImport.update({
  id: '/logout',
  path: '/logout',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardRouteRoute = DashboardRouteRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardIndexRoute = DashboardIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => DashboardRouteRoute,
} as any)
const DashboardRiskCheckRoute = DashboardRiskCheckRouteImport.update({
  id: '/risk-check',
  path: '/risk-check',
  getParentRoute: () => DashboardRouteRoute,
} as any)
const DashboardPromoterRoute = DashboardPromoterRouteImport.update({
  id: '/promoter',
  path: '/promoter',
  getParentRoute: () => DashboardRouteRoute,
} as any)
const DashboardOrdersRoute = DashboardOrdersRouteImport.update({
  id: '/orders',
  path: '/orders',
  getParentRoute: () => DashboardRouteRoute,
} as any)
const DashboardNovoSellRetryRoute = DashboardNovoSellRetryRouteImport.update({
  id: '/novo-sell-retry',
  path: '/novo-sell-retry',
  getParentRoute: () => DashboardRouteRoute,
} as any)
const DashboardMerchandiseRoute = DashboardMerchandiseRouteImport.update({
  id: '/merchandise',
  path: '/merchandise',
  getParentRoute: () => DashboardRouteRoute,
} as any)
const DashboardFailedOrdersRoute = DashboardFailedOrdersRouteImport.update({
  id: '/failed-orders',
  path: '/failed-orders',
  getParentRoute: () => DashboardRouteRoute,
} as any)
const DashboardCancelOrderRoute = DashboardCancelOrderRouteImport.update({
  id: '/cancel-order',
  path: '/cancel-order',
  getParentRoute: () => DashboardRouteRoute,
} as any)
const DashboardBulkOperationRoute = DashboardBulkOperationRouteImport.update({
  id: '/bulk-operation',
  path: '/bulk-operation',
  getParentRoute: () => DashboardRouteRoute,
} as any)
const DashboardBannerRoute = DashboardBannerRouteImport.update({
  id: '/banner',
  path: '/banner',
  getParentRoute: () => DashboardRouteRoute,
} as any)
const DashboardApkManagementRoute = DashboardApkManagementRouteImport.update({
  id: '/apk-management',
  path: '/apk-management',
  getParentRoute: () => DashboardRouteRoute,
} as any)
const DashboardAdminActionRoute = DashboardAdminActionRouteImport.update({
  id: '/admin-action',
  path: '/admin-action',
  getParentRoute: () => DashboardRouteRoute,
} as any)
const DashboardPromotersIndexRoute = DashboardPromotersIndexRouteImport.update({
  id: '/promoters/',
  path: '/promoters/',
  getParentRoute: () => DashboardRouteRoute,
} as any)
const DashboardProductIndexRoute = DashboardProductIndexRouteImport.update({
  id: '/product/',
  path: '/product/',
  getParentRoute: () => DashboardRouteRoute,
} as any)
const DashboardMasterControlIndexRoute =
  DashboardMasterControlIndexRouteImport.update({
    id: '/master-control/',
    path: '/master-control/',
    getParentRoute: () => DashboardRouteRoute,
  } as any)
const DashboardMaintenanceIndexRoute =
  DashboardMaintenanceIndexRouteImport.update({
    id: '/maintenance/',
    path: '/maintenance/',
    getParentRoute: () => DashboardRouteRoute,
  } as any)
const DashboardLeaderboardIndexRoute =
  DashboardLeaderboardIndexRouteImport.update({
    id: '/leaderboard/',
    path: '/leaderboard/',
    getParentRoute: () => DashboardRouteRoute,
  } as any)
const DashboardHorizonIndexRoute = DashboardHorizonIndexRouteImport.update({
  id: '/horizon/',
  path: '/horizon/',
  getParentRoute: () => DashboardRouteRoute,
} as any)
const DashboardFantasyIndexRoute = DashboardFantasyIndexRouteImport.update({
  id: '/fantasy/',
  path: '/fantasy/',
  getParentRoute: () => DashboardRouteRoute,
} as any)
const DashboardCompaniesIndexRoute = DashboardCompaniesIndexRouteImport.update({
  id: '/companies/',
  path: '/companies/',
  getParentRoute: () => DashboardRouteRoute,
} as any)
const DashboardCategoryIndexRoute = DashboardCategoryIndexRouteImport.update({
  id: '/category/',
  path: '/category/',
  getParentRoute: () => DashboardRouteRoute,
} as any)
const DashboardBrandIndexRoute = DashboardBrandIndexRouteImport.update({
  id: '/brand/',
  path: '/brand/',
  getParentRoute: () => DashboardRouteRoute,
} as any)
const DashboardBannerManagementIndexRoute =
  DashboardBannerManagementIndexRouteImport.update({
    id: '/banner-management/',
    path: '/banner-management/',
    getParentRoute: () => DashboardRouteRoute,
  } as any)
const DashboardAdminLogsIndexRoute = DashboardAdminLogsIndexRouteImport.update({
  id: '/admin-logs/',
  path: '/admin-logs/',
  getParentRoute: () => DashboardRouteRoute,
} as any)
const DashboardAdminApprovalsIndexRoute =
  DashboardAdminApprovalsIndexRouteImport.update({
    id: '/admin-approvals/',
    path: '/admin-approvals/',
    getParentRoute: () => DashboardRouteRoute,
  } as any)
const DashboardSupportPushNotificationRoute =
  DashboardSupportPushNotificationRouteImport.update({
    id: '/support/push-notification',
    path: '/support/push-notification',
    getParentRoute: () => DashboardRouteRoute,
  } as any)
const DashboardSupportManageUserRoute =
  DashboardSupportManageUserRouteImport.update({
    id: '/support/manage-user',
    path: '/support/manage-user',
    getParentRoute: () => DashboardRouteRoute,
  } as any)
const DashboardSupportEscalateIssueRoute =
  DashboardSupportEscalateIssueRouteImport.update({
    id: '/support/escalate-issue',
    path: '/support/escalate-issue',
    getParentRoute: () => DashboardRouteRoute,
  } as any)
const DashboardPromotersPromoterIdRoute =
  DashboardPromotersPromoterIdRouteImport.update({
    id: '/promoters/$promoterId',
    path: '/promoters/$promoterId',
    getParentRoute: () => DashboardRouteRoute,
  } as any)
const DashboardProductTrackOrderRoute =
  DashboardProductTrackOrderRouteImport.update({
    id: '/product/track-order',
    path: '/product/track-order',
    getParentRoute: () => DashboardRouteRoute,
  } as any)
const DashboardProductManageVoucherRoute =
  DashboardProductManageVoucherRouteImport.update({
    id: '/product/manage-voucher',
    path: '/product/manage-voucher',
    getParentRoute: () => DashboardRouteRoute,
  } as any)
const DashboardProductIdRoute = DashboardProductIdRouteImport.update({
  id: '/product/$id',
  path: '/product/$id',
  getParentRoute: () => DashboardRouteRoute,
} as any)
const DashboardLeaderboardAddRoute = DashboardLeaderboardAddRouteImport.update({
  id: '/leaderboard/add',
  path: '/leaderboard/add',
  getParentRoute: () => DashboardRouteRoute,
} as any)
const DashboardLeaderboardIdRoute = DashboardLeaderboardIdRouteImport.update({
  id: '/leaderboard/$id',
  path: '/leaderboard/$id',
  getParentRoute: () => DashboardRouteRoute,
} as any)
const DashboardFantasyPlayersRoute = DashboardFantasyPlayersRouteImport.update({
  id: '/fantasy/players',
  path: '/fantasy/players',
  getParentRoute: () => DashboardRouteRoute,
} as any)
const DashboardFantasyContestGroupRoute =
  DashboardFantasyContestGroupRouteImport.update({
    id: '/fantasy/contest-group',
    path: '/fantasy/contest-group',
    getParentRoute: () => DashboardRouteRoute,
  } as any)
const DashboardCompaniesAddRoute = DashboardCompaniesAddRouteImport.update({
  id: '/companies/add',
  path: '/companies/add',
  getParentRoute: () => DashboardRouteRoute,
} as any)
const DashboardCompaniesIdRoute = DashboardCompaniesIdRouteImport.update({
  id: '/companies/$id',
  path: '/companies/$id',
  getParentRoute: () => DashboardRouteRoute,
} as any)
const DashboardBannerManagementNewRoute =
  DashboardBannerManagementNewRouteImport.update({
    id: '/banner-management/new',
    path: '/banner-management/new',
    getParentRoute: () => DashboardRouteRoute,
  } as any)
const DashboardBannerManagementBannerIdRoute =
  DashboardBannerManagementBannerIdRouteImport.update({
    id: '/banner-management/$bannerId',
    path: '/banner-management/$bannerId',
    getParentRoute: () => DashboardRouteRoute,
  } as any)
const AdminAuthSuccessRoute = AdminAuthSuccessRouteImport.update({
  id: '/admin/auth/success',
  path: '/admin/auth/success',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardFantasyCreateContestRouteRoute =
  DashboardFantasyCreateContestRouteRouteImport.update({
    id: '/fantasy/create-contest',
    path: '/fantasy/create-contest',
    getParentRoute: () => DashboardRouteRoute,
  } as any)
const DashboardPromotersWithdrawRequestIndexRoute =
  DashboardPromotersWithdrawRequestIndexRouteImport.update({
    id: '/promoters/withdraw-request/',
    path: '/promoters/withdraw-request/',
    getParentRoute: () => DashboardRouteRoute,
  } as any)
const DashboardPromotersVerificationIndexRoute =
  DashboardPromotersVerificationIndexRouteImport.update({
    id: '/promoters/verification/',
    path: '/promoters/verification/',
    getParentRoute: () => DashboardRouteRoute,
  } as any)
const DashboardPromotersRequestsIndexRoute =
  DashboardPromotersRequestsIndexRouteImport.update({
    id: '/promoters/requests/',
    path: '/promoters/requests/',
    getParentRoute: () => DashboardRouteRoute,
  } as any)
const DashboardProductComboIndexRoute =
  DashboardProductComboIndexRouteImport.update({
    id: '/product/combo/',
    path: '/product/combo/',
    getParentRoute: () => DashboardRouteRoute,
  } as any)
const DashboardProductAddProductIndexRoute =
  DashboardProductAddProductIndexRouteImport.update({
    id: '/product/add-product/',
    path: '/product/add-product/',
    getParentRoute: () => DashboardRouteRoute,
  } as any)
const DashboardHorizonTopicsIndexRoute =
  DashboardHorizonTopicsIndexRouteImport.update({
    id: '/horizon/topics/',
    path: '/horizon/topics/',
    getParentRoute: () => DashboardRouteRoute,
  } as any)
const DashboardHorizonEventTemplatesIndexRoute =
  DashboardHorizonEventTemplatesIndexRouteImport.update({
    id: '/horizon/event-templates/',
    path: '/horizon/event-templates/',
    getParentRoute: () => DashboardRouteRoute,
  } as any)
const DashboardHorizonCategoriesIndexRoute =
  DashboardHorizonCategoriesIndexRouteImport.update({
    id: '/horizon/categories/',
    path: '/horizon/categories/',
    getParentRoute: () => DashboardRouteRoute,
  } as any)
const DashboardFantasyTeamsIndexRoute =
  DashboardFantasyTeamsIndexRouteImport.update({
    id: '/fantasy/teams/',
    path: '/fantasy/teams/',
    getParentRoute: () => DashboardRouteRoute,
  } as any)
const DashboardFantasyLeagueManagementIndexRoute =
  DashboardFantasyLeagueManagementIndexRouteImport.update({
    id: '/fantasy/league-management/',
    path: '/fantasy/league-management/',
    getParentRoute: () => DashboardRouteRoute,
  } as any)
const DashboardFantasyHomeManagementIndexRoute =
  DashboardFantasyHomeManagementIndexRouteImport.update({
    id: '/fantasy/home-management/',
    path: '/fantasy/home-management/',
    getParentRoute: () => DashboardRouteRoute,
  } as any)
const DashboardFantasyFixtureIndexRoute =
  DashboardFantasyFixtureIndexRouteImport.update({
    id: '/fantasy/fixture/',
    path: '/fantasy/fixture/',
    getParentRoute: () => DashboardRouteRoute,
  } as any)
const DashboardFantasyCreateContestIndexRoute =
  DashboardFantasyCreateContestIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => DashboardFantasyCreateContestRouteRoute,
  } as any)
const DashboardFantasyContestTemplateIndexRoute =
  DashboardFantasyContestTemplateIndexRouteImport.update({
    id: '/fantasy/contest-template/',
    path: '/fantasy/contest-template/',
    getParentRoute: () => DashboardRouteRoute,
  } as any)
const DashboardCategoryAddCategoryIndexRoute =
  DashboardCategoryAddCategoryIndexRouteImport.update({
    id: '/category/add-category/',
    path: '/category/add-category/',
    getParentRoute: () => DashboardRouteRoute,
  } as any)
const DashboardBrandAddBrandIndexRoute =
  DashboardBrandAddBrandIndexRouteImport.update({
    id: '/brand/add-brand/',
    path: '/brand/add-brand/',
    getParentRoute: () => DashboardRouteRoute,
  } as any)
const DashboardSupportManageUserTransactionRoute =
  DashboardSupportManageUserTransactionRouteImport.update({
    id: '/transaction',
    path: '/transaction',
    getParentRoute: () => DashboardSupportManageUserRoute,
  } as any)
const DashboardSupportManageUserOrderHistoryRoute =
  DashboardSupportManageUserOrderHistoryRouteImport.update({
    id: '/order-history',
    path: '/order-history',
    getParentRoute: () => DashboardSupportManageUserRoute,
  } as any)
const DashboardSupportManageUserGameplayHistoryRoute =
  DashboardSupportManageUserGameplayHistoryRouteImport.update({
    id: '/gameplay-history',
    path: '/gameplay-history',
    getParentRoute: () => DashboardSupportManageUserRoute,
  } as any)
const DashboardSupportManageUserFantasyHistoryRoute =
  DashboardSupportManageUserFantasyHistoryRouteImport.update({
    id: '/fantasy-history',
    path: '/fantasy-history',
    getParentRoute: () => DashboardSupportManageUserRoute,
  } as any)
const DashboardSupportManageUserAviatorHistoryRoute =
  DashboardSupportManageUserAviatorHistoryRouteImport.update({
    id: '/aviator-history',
    path: '/aviator-history',
    getParentRoute: () => DashboardSupportManageUserRoute,
  } as any)
const DashboardPromotersWithdrawRequestWithdrawalIdRoute =
  DashboardPromotersWithdrawRequestWithdrawalIdRouteImport.update({
    id: '/promoters/withdraw-request/$withdrawalId',
    path: '/promoters/withdraw-request/$withdrawalId',
    getParentRoute: () => DashboardRouteRoute,
  } as any)
const DashboardPromotersVerificationVerificationIdRoute =
  DashboardPromotersVerificationVerificationIdRouteImport.update({
    id: '/promoters/verification/$verificationId',
    path: '/promoters/verification/$verificationId',
    getParentRoute: () => DashboardRouteRoute,
  } as any)
const DashboardPromotersRequestsRequestIdRoute =
  DashboardPromotersRequestsRequestIdRouteImport.update({
    id: '/promoters/requests/$requestId',
    path: '/promoters/requests/$requestId',
    getParentRoute: () => DashboardRouteRoute,
  } as any)
const DashboardProductComboIdRoute = DashboardProductComboIdRouteImport.update({
  id: '/product/combo/$id',
  path: '/product/combo/$id',
  getParentRoute: () => DashboardRouteRoute,
} as any)
const DashboardLeaderboardCloneIdRoute =
  DashboardLeaderboardCloneIdRouteImport.update({
    id: '/leaderboard/clone/$id',
    path: '/leaderboard/clone/$id',
    getParentRoute: () => DashboardRouteRoute,
  } as any)
const DashboardHorizonTopicsIdRoute =
  DashboardHorizonTopicsIdRouteImport.update({
    id: '/horizon/topics/$id',
    path: '/horizon/topics/$id',
    getParentRoute: () => DashboardRouteRoute,
  } as any)
const DashboardFantasyLeagueManagementAddTourRoute =
  DashboardFantasyLeagueManagementAddTourRouteImport.update({
    id: '/fantasy/league-management/add-tour',
    path: '/fantasy/league-management/add-tour',
    getParentRoute: () => DashboardRouteRoute,
  } as any)
const DashboardFantasyFixtureFixtureTeamManagementRoute =
  DashboardFantasyFixtureFixtureTeamManagementRouteImport.update({
    id: '/fantasy/fixture/fixture-team-management',
    path: '/fantasy/fixture/fixture-team-management',
    getParentRoute: () => DashboardRouteRoute,
  } as any)
const DashboardFantasyFixtureContestTemplateDetailsRoute =
  DashboardFantasyFixtureContestTemplateDetailsRouteImport.update({
    id: '/fantasy/fixture/contest-template-details',
    path: '/fantasy/fixture/contest-template-details',
    getParentRoute: () => DashboardRouteRoute,
  } as any)
const DashboardFantasyFixtureContestCategoryRoute =
  DashboardFantasyFixtureContestCategoryRouteImport.update({
    id: '/fantasy/fixture/contest-category',
    path: '/fantasy/fixture/contest-category',
    getParentRoute: () => DashboardRouteRoute,
  } as any)
const DashboardFantasyFixtureChooseFromTemplateRoute =
  DashboardFantasyFixtureChooseFromTemplateRouteImport.update({
    id: '/fantasy/fixture/choose-from-template',
    path: '/fantasy/fixture/choose-from-template',
    getParentRoute: () => DashboardRouteRoute,
  } as any)
const DashboardFantasyContestTemplateDetailsRoute =
  DashboardFantasyContestTemplateDetailsRouteImport.update({
    id: '/fantasy/contest-template/details',
    path: '/fantasy/contest-template/details',
    getParentRoute: () => DashboardRouteRoute,
  } as any)
const DashboardCategoryAddCategoryCategoryImageRoute =
  DashboardCategoryAddCategoryCategoryImageRouteImport.update({
    id: '/category/add-category/category-image',
    path: '/category/add-category/category-image',
    getParentRoute: () => DashboardRouteRoute,
  } as any)
const DashboardBrandAddBrandAddBrandPropsRoute =
  DashboardBrandAddBrandAddBrandPropsRouteImport.update({
    id: '/brand/add-brand/add-brand-props',
    path: '/brand/add-brand/add-brand-props',
    getParentRoute: () => DashboardRouteRoute,
  } as any)
const DashboardFantasyFixtureContestWinnerManagementV2RouteRoute =
  DashboardFantasyFixtureContestWinnerManagementV2RouteRouteImport.update({
    id: '/fantasy/fixture/contest-winner-management-v2',
    path: '/fantasy/fixture/contest-winner-management-v2',
    getParentRoute: () => DashboardRouteRoute,
  } as any)
const DashboardFantasyContestTemplateAddTemplateRouteRoute =
  DashboardFantasyContestTemplateAddTemplateRouteRouteImport.update({
    id: '/fantasy/contest-template/add-template',
    path: '/fantasy/contest-template/add-template',
    getParentRoute: () => DashboardRouteRoute,
  } as any)
const DashboardProductComboAddCombinationIndexRoute =
  DashboardProductComboAddCombinationIndexRouteImport.update({
    id: '/product/combo/add-combination/',
    path: '/product/combo/add-combination/',
    getParentRoute: () => DashboardRouteRoute,
  } as any)
const DashboardProductAddProductSaleSettingsIndexRoute =
  DashboardProductAddProductSaleSettingsIndexRouteImport.update({
    id: '/product/add-product/sale-settings/',
    path: '/product/add-product/sale-settings/',
    getParentRoute: () => DashboardRouteRoute,
  } as any)
const DashboardHorizonEventTemplatesRequestsIndexRoute =
  DashboardHorizonEventTemplatesRequestsIndexRouteImport.update({
    id: '/horizon/event-templates/requests/',
    path: '/horizon/event-templates/requests/',
    getParentRoute: () => DashboardRouteRoute,
  } as any)
const DashboardFantasyFixtureContestWinnerManagementIndexRoute =
  DashboardFantasyFixtureContestWinnerManagementIndexRouteImport.update({
    id: '/fantasy/fixture/contest-winner-management/',
    path: '/fantasy/fixture/contest-winner-management/',
    getParentRoute: () => DashboardRouteRoute,
  } as any)
const DashboardFantasyFixtureContestWinnerManagementV2IndexRoute =
  DashboardFantasyFixtureContestWinnerManagementV2IndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      DashboardFantasyFixtureContestWinnerManagementV2RouteRoute,
  } as any)
const DashboardFantasyFixtureContestDetailsIndexRoute =
  DashboardFantasyFixtureContestDetailsIndexRouteImport.update({
    id: '/fantasy/fixture/contest-details/',
    path: '/fantasy/fixture/contest-details/',
    getParentRoute: () => DashboardRouteRoute,
  } as any)
const DashboardFantasyContestTemplateAddTemplateIndexRoute =
  DashboardFantasyContestTemplateAddTemplateIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => DashboardFantasyContestTemplateAddTemplateRouteRoute,
  } as any)
const DashboardFantasyFixtureContestDetailsUserPlayersRoute =
  DashboardFantasyFixtureContestDetailsUserPlayersRouteImport.update({
    id: '/fantasy/fixture/contest-details/user-players',
    path: '/fantasy/fixture/contest-details/user-players',
    getParentRoute: () => DashboardRouteRoute,
  } as any)
const DashboardProductAddProductSaleSettingsProductSettingsIndexRoute =
  DashboardProductAddProductSaleSettingsProductSettingsIndexRouteImport.update({
    id: '/product/add-product/sale-settings/product-settings/',
    path: '/product/add-product/sale-settings/product-settings/',
    getParentRoute: () => DashboardRouteRoute,
  } as any)
const DashboardProductAddProductSaleSettingsProductSettingsInvoiceDetailsRoute =
  DashboardProductAddProductSaleSettingsProductSettingsInvoiceDetailsRouteImport.update(
    {
      id: '/product/add-product/sale-settings/product-settings/invoice-details',
      path: '/product/add-product/sale-settings/product-settings/invoice-details',
      getParentRoute: () => DashboardRouteRoute,
    } as any,
  )

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/dashboard': typeof DashboardRouteRouteWithChildren
  '/login': typeof LoginRoute
  '/logout': typeof LogoutRoute
  '/dashboard/admin-action': typeof DashboardAdminActionRoute
  '/dashboard/apk-management': typeof DashboardApkManagementRoute
  '/dashboard/banner': typeof DashboardBannerRoute
  '/dashboard/bulk-operation': typeof DashboardBulkOperationRoute
  '/dashboard/cancel-order': typeof DashboardCancelOrderRoute
  '/dashboard/failed-orders': typeof DashboardFailedOrdersRoute
  '/dashboard/merchandise': typeof DashboardMerchandiseRoute
  '/dashboard/novo-sell-retry': typeof DashboardNovoSellRetryRoute
  '/dashboard/orders': typeof DashboardOrdersRoute
  '/dashboard/promoter': typeof DashboardPromoterRoute
  '/dashboard/risk-check': typeof DashboardRiskCheckRoute
  '/dashboard/': typeof DashboardIndexRoute
  '/dashboard/fantasy/create-contest': typeof DashboardFantasyCreateContestRouteRouteWithChildren
  '/admin/auth/success': typeof AdminAuthSuccessRoute
  '/dashboard/banner-management/$bannerId': typeof DashboardBannerManagementBannerIdRoute
  '/dashboard/banner-management/new': typeof DashboardBannerManagementNewRoute
  '/dashboard/companies/$id': typeof DashboardCompaniesIdRoute
  '/dashboard/companies/add': typeof DashboardCompaniesAddRoute
  '/dashboard/fantasy/contest-group': typeof DashboardFantasyContestGroupRoute
  '/dashboard/fantasy/players': typeof DashboardFantasyPlayersRoute
  '/dashboard/leaderboard/$id': typeof DashboardLeaderboardIdRoute
  '/dashboard/leaderboard/add': typeof DashboardLeaderboardAddRoute
  '/dashboard/product/$id': typeof DashboardProductIdRoute
  '/dashboard/product/manage-voucher': typeof DashboardProductManageVoucherRoute
  '/dashboard/product/track-order': typeof DashboardProductTrackOrderRoute
  '/dashboard/promoters/$promoterId': typeof DashboardPromotersPromoterIdRoute
  '/dashboard/support/escalate-issue': typeof DashboardSupportEscalateIssueRoute
  '/dashboard/support/manage-user': typeof DashboardSupportManageUserRouteWithChildren
  '/dashboard/support/push-notification': typeof DashboardSupportPushNotificationRoute
  '/dashboard/admin-approvals': typeof DashboardAdminApprovalsIndexRoute
  '/dashboard/admin-logs': typeof DashboardAdminLogsIndexRoute
  '/dashboard/banner-management': typeof DashboardBannerManagementIndexRoute
  '/dashboard/brand': typeof DashboardBrandIndexRoute
  '/dashboard/category': typeof DashboardCategoryIndexRoute
  '/dashboard/companies': typeof DashboardCompaniesIndexRoute
  '/dashboard/fantasy': typeof DashboardFantasyIndexRoute
  '/dashboard/horizon': typeof DashboardHorizonIndexRoute
  '/dashboard/leaderboard': typeof DashboardLeaderboardIndexRoute
  '/dashboard/maintenance': typeof DashboardMaintenanceIndexRoute
  '/dashboard/master-control': typeof DashboardMasterControlIndexRoute
  '/dashboard/product': typeof DashboardProductIndexRoute
  '/dashboard/promoters': typeof DashboardPromotersIndexRoute
  '/dashboard/fantasy/contest-template/add-template': typeof DashboardFantasyContestTemplateAddTemplateRouteRouteWithChildren
  '/dashboard/fantasy/fixture/contest-winner-management-v2': typeof DashboardFantasyFixtureContestWinnerManagementV2RouteRouteWithChildren
  '/dashboard/brand/add-brand/add-brand-props': typeof DashboardBrandAddBrandAddBrandPropsRoute
  '/dashboard/category/add-category/category-image': typeof DashboardCategoryAddCategoryCategoryImageRoute
  '/dashboard/fantasy/contest-template/details': typeof DashboardFantasyContestTemplateDetailsRoute
  '/dashboard/fantasy/fixture/choose-from-template': typeof DashboardFantasyFixtureChooseFromTemplateRoute
  '/dashboard/fantasy/fixture/contest-category': typeof DashboardFantasyFixtureContestCategoryRoute
  '/dashboard/fantasy/fixture/contest-template-details': typeof DashboardFantasyFixtureContestTemplateDetailsRoute
  '/dashboard/fantasy/fixture/fixture-team-management': typeof DashboardFantasyFixtureFixtureTeamManagementRoute
  '/dashboard/fantasy/league-management/add-tour': typeof DashboardFantasyLeagueManagementAddTourRoute
  '/dashboard/horizon/topics/$id': typeof DashboardHorizonTopicsIdRoute
  '/dashboard/leaderboard/clone/$id': typeof DashboardLeaderboardCloneIdRoute
  '/dashboard/product/combo/$id': typeof DashboardProductComboIdRoute
  '/dashboard/promoters/requests/$requestId': typeof DashboardPromotersRequestsRequestIdRoute
  '/dashboard/promoters/verification/$verificationId': typeof DashboardPromotersVerificationVerificationIdRoute
  '/dashboard/promoters/withdraw-request/$withdrawalId': typeof DashboardPromotersWithdrawRequestWithdrawalIdRoute
  '/dashboard/support/manage-user/aviator-history': typeof DashboardSupportManageUserAviatorHistoryRoute
  '/dashboard/support/manage-user/fantasy-history': typeof DashboardSupportManageUserFantasyHistoryRoute
  '/dashboard/support/manage-user/gameplay-history': typeof DashboardSupportManageUserGameplayHistoryRoute
  '/dashboard/support/manage-user/order-history': typeof DashboardSupportManageUserOrderHistoryRoute
  '/dashboard/support/manage-user/transaction': typeof DashboardSupportManageUserTransactionRoute
  '/dashboard/brand/add-brand': typeof DashboardBrandAddBrandIndexRoute
  '/dashboard/category/add-category': typeof DashboardCategoryAddCategoryIndexRoute
  '/dashboard/fantasy/contest-template': typeof DashboardFantasyContestTemplateIndexRoute
  '/dashboard/fantasy/create-contest/': typeof DashboardFantasyCreateContestIndexRoute
  '/dashboard/fantasy/fixture': typeof DashboardFantasyFixtureIndexRoute
  '/dashboard/fantasy/home-management': typeof DashboardFantasyHomeManagementIndexRoute
  '/dashboard/fantasy/league-management': typeof DashboardFantasyLeagueManagementIndexRoute
  '/dashboard/fantasy/teams': typeof DashboardFantasyTeamsIndexRoute
  '/dashboard/horizon/categories': typeof DashboardHorizonCategoriesIndexRoute
  '/dashboard/horizon/event-templates': typeof DashboardHorizonEventTemplatesIndexRoute
  '/dashboard/horizon/topics': typeof DashboardHorizonTopicsIndexRoute
  '/dashboard/product/add-product': typeof DashboardProductAddProductIndexRoute
  '/dashboard/product/combo': typeof DashboardProductComboIndexRoute
  '/dashboard/promoters/requests': typeof DashboardPromotersRequestsIndexRoute
  '/dashboard/promoters/verification': typeof DashboardPromotersVerificationIndexRoute
  '/dashboard/promoters/withdraw-request': typeof DashboardPromotersWithdrawRequestIndexRoute
  '/dashboard/fantasy/fixture/contest-details/user-players': typeof DashboardFantasyFixtureContestDetailsUserPlayersRoute
  '/dashboard/fantasy/contest-template/add-template/': typeof DashboardFantasyContestTemplateAddTemplateIndexRoute
  '/dashboard/fantasy/fixture/contest-details': typeof DashboardFantasyFixtureContestDetailsIndexRoute
  '/dashboard/fantasy/fixture/contest-winner-management-v2/': typeof DashboardFantasyFixtureContestWinnerManagementV2IndexRoute
  '/dashboard/fantasy/fixture/contest-winner-management': typeof DashboardFantasyFixtureContestWinnerManagementIndexRoute
  '/dashboard/horizon/event-templates/requests': typeof DashboardHorizonEventTemplatesRequestsIndexRoute
  '/dashboard/product/add-product/sale-settings': typeof DashboardProductAddProductSaleSettingsIndexRoute
  '/dashboard/product/combo/add-combination': typeof DashboardProductComboAddCombinationIndexRoute
  '/dashboard/product/add-product/sale-settings/product-settings/invoice-details': typeof DashboardProductAddProductSaleSettingsProductSettingsInvoiceDetailsRoute
  '/dashboard/product/add-product/sale-settings/product-settings': typeof DashboardProductAddProductSaleSettingsProductSettingsIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/logout': typeof LogoutRoute
  '/dashboard/admin-action': typeof DashboardAdminActionRoute
  '/dashboard/apk-management': typeof DashboardApkManagementRoute
  '/dashboard/banner': typeof DashboardBannerRoute
  '/dashboard/bulk-operation': typeof DashboardBulkOperationRoute
  '/dashboard/cancel-order': typeof DashboardCancelOrderRoute
  '/dashboard/failed-orders': typeof DashboardFailedOrdersRoute
  '/dashboard/merchandise': typeof DashboardMerchandiseRoute
  '/dashboard/novo-sell-retry': typeof DashboardNovoSellRetryRoute
  '/dashboard/orders': typeof DashboardOrdersRoute
  '/dashboard/promoter': typeof DashboardPromoterRoute
  '/dashboard/risk-check': typeof DashboardRiskCheckRoute
  '/dashboard': typeof DashboardIndexRoute
  '/admin/auth/success': typeof AdminAuthSuccessRoute
  '/dashboard/banner-management/$bannerId': typeof DashboardBannerManagementBannerIdRoute
  '/dashboard/banner-management/new': typeof DashboardBannerManagementNewRoute
  '/dashboard/companies/$id': typeof DashboardCompaniesIdRoute
  '/dashboard/companies/add': typeof DashboardCompaniesAddRoute
  '/dashboard/fantasy/contest-group': typeof DashboardFantasyContestGroupRoute
  '/dashboard/fantasy/players': typeof DashboardFantasyPlayersRoute
  '/dashboard/leaderboard/$id': typeof DashboardLeaderboardIdRoute
  '/dashboard/leaderboard/add': typeof DashboardLeaderboardAddRoute
  '/dashboard/product/$id': typeof DashboardProductIdRoute
  '/dashboard/product/manage-voucher': typeof DashboardProductManageVoucherRoute
  '/dashboard/product/track-order': typeof DashboardProductTrackOrderRoute
  '/dashboard/promoters/$promoterId': typeof DashboardPromotersPromoterIdRoute
  '/dashboard/support/escalate-issue': typeof DashboardSupportEscalateIssueRoute
  '/dashboard/support/manage-user': typeof DashboardSupportManageUserRouteWithChildren
  '/dashboard/support/push-notification': typeof DashboardSupportPushNotificationRoute
  '/dashboard/admin-approvals': typeof DashboardAdminApprovalsIndexRoute
  '/dashboard/admin-logs': typeof DashboardAdminLogsIndexRoute
  '/dashboard/banner-management': typeof DashboardBannerManagementIndexRoute
  '/dashboard/brand': typeof DashboardBrandIndexRoute
  '/dashboard/category': typeof DashboardCategoryIndexRoute
  '/dashboard/companies': typeof DashboardCompaniesIndexRoute
  '/dashboard/fantasy': typeof DashboardFantasyIndexRoute
  '/dashboard/horizon': typeof DashboardHorizonIndexRoute
  '/dashboard/leaderboard': typeof DashboardLeaderboardIndexRoute
  '/dashboard/maintenance': typeof DashboardMaintenanceIndexRoute
  '/dashboard/master-control': typeof DashboardMasterControlIndexRoute
  '/dashboard/product': typeof DashboardProductIndexRoute
  '/dashboard/promoters': typeof DashboardPromotersIndexRoute
  '/dashboard/brand/add-brand/add-brand-props': typeof DashboardBrandAddBrandAddBrandPropsRoute
  '/dashboard/category/add-category/category-image': typeof DashboardCategoryAddCategoryCategoryImageRoute
  '/dashboard/fantasy/contest-template/details': typeof DashboardFantasyContestTemplateDetailsRoute
  '/dashboard/fantasy/fixture/choose-from-template': typeof DashboardFantasyFixtureChooseFromTemplateRoute
  '/dashboard/fantasy/fixture/contest-category': typeof DashboardFantasyFixtureContestCategoryRoute
  '/dashboard/fantasy/fixture/contest-template-details': typeof DashboardFantasyFixtureContestTemplateDetailsRoute
  '/dashboard/fantasy/fixture/fixture-team-management': typeof DashboardFantasyFixtureFixtureTeamManagementRoute
  '/dashboard/fantasy/league-management/add-tour': typeof DashboardFantasyLeagueManagementAddTourRoute
  '/dashboard/horizon/topics/$id': typeof DashboardHorizonTopicsIdRoute
  '/dashboard/leaderboard/clone/$id': typeof DashboardLeaderboardCloneIdRoute
  '/dashboard/product/combo/$id': typeof DashboardProductComboIdRoute
  '/dashboard/promoters/requests/$requestId': typeof DashboardPromotersRequestsRequestIdRoute
  '/dashboard/promoters/verification/$verificationId': typeof DashboardPromotersVerificationVerificationIdRoute
  '/dashboard/promoters/withdraw-request/$withdrawalId': typeof DashboardPromotersWithdrawRequestWithdrawalIdRoute
  '/dashboard/support/manage-user/aviator-history': typeof DashboardSupportManageUserAviatorHistoryRoute
  '/dashboard/support/manage-user/fantasy-history': typeof DashboardSupportManageUserFantasyHistoryRoute
  '/dashboard/support/manage-user/gameplay-history': typeof DashboardSupportManageUserGameplayHistoryRoute
  '/dashboard/support/manage-user/order-history': typeof DashboardSupportManageUserOrderHistoryRoute
  '/dashboard/support/manage-user/transaction': typeof DashboardSupportManageUserTransactionRoute
  '/dashboard/brand/add-brand': typeof DashboardBrandAddBrandIndexRoute
  '/dashboard/category/add-category': typeof DashboardCategoryAddCategoryIndexRoute
  '/dashboard/fantasy/contest-template': typeof DashboardFantasyContestTemplateIndexRoute
  '/dashboard/fantasy/create-contest': typeof DashboardFantasyCreateContestIndexRoute
  '/dashboard/fantasy/fixture': typeof DashboardFantasyFixtureIndexRoute
  '/dashboard/fantasy/home-management': typeof DashboardFantasyHomeManagementIndexRoute
  '/dashboard/fantasy/league-management': typeof DashboardFantasyLeagueManagementIndexRoute
  '/dashboard/fantasy/teams': typeof DashboardFantasyTeamsIndexRoute
  '/dashboard/horizon/categories': typeof DashboardHorizonCategoriesIndexRoute
  '/dashboard/horizon/event-templates': typeof DashboardHorizonEventTemplatesIndexRoute
  '/dashboard/horizon/topics': typeof DashboardHorizonTopicsIndexRoute
  '/dashboard/product/add-product': typeof DashboardProductAddProductIndexRoute
  '/dashboard/product/combo': typeof DashboardProductComboIndexRoute
  '/dashboard/promoters/requests': typeof DashboardPromotersRequestsIndexRoute
  '/dashboard/promoters/verification': typeof DashboardPromotersVerificationIndexRoute
  '/dashboard/promoters/withdraw-request': typeof DashboardPromotersWithdrawRequestIndexRoute
  '/dashboard/fantasy/fixture/contest-details/user-players': typeof DashboardFantasyFixtureContestDetailsUserPlayersRoute
  '/dashboard/fantasy/contest-template/add-template': typeof DashboardFantasyContestTemplateAddTemplateIndexRoute
  '/dashboard/fantasy/fixture/contest-details': typeof DashboardFantasyFixtureContestDetailsIndexRoute
  '/dashboard/fantasy/fixture/contest-winner-management-v2': typeof DashboardFantasyFixtureContestWinnerManagementV2IndexRoute
  '/dashboard/fantasy/fixture/contest-winner-management': typeof DashboardFantasyFixtureContestWinnerManagementIndexRoute
  '/dashboard/horizon/event-templates/requests': typeof DashboardHorizonEventTemplatesRequestsIndexRoute
  '/dashboard/product/add-product/sale-settings': typeof DashboardProductAddProductSaleSettingsIndexRoute
  '/dashboard/product/combo/add-combination': typeof DashboardProductComboAddCombinationIndexRoute
  '/dashboard/product/add-product/sale-settings/product-settings/invoice-details': typeof DashboardProductAddProductSaleSettingsProductSettingsInvoiceDetailsRoute
  '/dashboard/product/add-product/sale-settings/product-settings': typeof DashboardProductAddProductSaleSettingsProductSettingsIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/dashboard': typeof DashboardRouteRouteWithChildren
  '/login': typeof LoginRoute
  '/logout': typeof LogoutRoute
  '/dashboard/admin-action': typeof DashboardAdminActionRoute
  '/dashboard/apk-management': typeof DashboardApkManagementRoute
  '/dashboard/banner': typeof DashboardBannerRoute
  '/dashboard/bulk-operation': typeof DashboardBulkOperationRoute
  '/dashboard/cancel-order': typeof DashboardCancelOrderRoute
  '/dashboard/failed-orders': typeof DashboardFailedOrdersRoute
  '/dashboard/merchandise': typeof DashboardMerchandiseRoute
  '/dashboard/novo-sell-retry': typeof DashboardNovoSellRetryRoute
  '/dashboard/orders': typeof DashboardOrdersRoute
  '/dashboard/promoter': typeof DashboardPromoterRoute
  '/dashboard/risk-check': typeof DashboardRiskCheckRoute
  '/dashboard/': typeof DashboardIndexRoute
  '/dashboard/fantasy/create-contest': typeof DashboardFantasyCreateContestRouteRouteWithChildren
  '/admin/auth/success': typeof AdminAuthSuccessRoute
  '/dashboard/banner-management/$bannerId': typeof DashboardBannerManagementBannerIdRoute
  '/dashboard/banner-management/new': typeof DashboardBannerManagementNewRoute
  '/dashboard/companies/$id': typeof DashboardCompaniesIdRoute
  '/dashboard/companies/add': typeof DashboardCompaniesAddRoute
  '/dashboard/fantasy/contest-group': typeof DashboardFantasyContestGroupRoute
  '/dashboard/fantasy/players': typeof DashboardFantasyPlayersRoute
  '/dashboard/leaderboard/$id': typeof DashboardLeaderboardIdRoute
  '/dashboard/leaderboard/add': typeof DashboardLeaderboardAddRoute
  '/dashboard/product/$id': typeof DashboardProductIdRoute
  '/dashboard/product/manage-voucher': typeof DashboardProductManageVoucherRoute
  '/dashboard/product/track-order': typeof DashboardProductTrackOrderRoute
  '/dashboard/promoters/$promoterId': typeof DashboardPromotersPromoterIdRoute
  '/dashboard/support/escalate-issue': typeof DashboardSupportEscalateIssueRoute
  '/dashboard/support/manage-user': typeof DashboardSupportManageUserRouteWithChildren
  '/dashboard/support/push-notification': typeof DashboardSupportPushNotificationRoute
  '/dashboard/admin-approvals/': typeof DashboardAdminApprovalsIndexRoute
  '/dashboard/admin-logs/': typeof DashboardAdminLogsIndexRoute
  '/dashboard/banner-management/': typeof DashboardBannerManagementIndexRoute
  '/dashboard/brand/': typeof DashboardBrandIndexRoute
  '/dashboard/category/': typeof DashboardCategoryIndexRoute
  '/dashboard/companies/': typeof DashboardCompaniesIndexRoute
  '/dashboard/fantasy/': typeof DashboardFantasyIndexRoute
  '/dashboard/horizon/': typeof DashboardHorizonIndexRoute
  '/dashboard/leaderboard/': typeof DashboardLeaderboardIndexRoute
  '/dashboard/maintenance/': typeof DashboardMaintenanceIndexRoute
  '/dashboard/master-control/': typeof DashboardMasterControlIndexRoute
  '/dashboard/product/': typeof DashboardProductIndexRoute
  '/dashboard/promoters/': typeof DashboardPromotersIndexRoute
  '/dashboard/fantasy/contest-template/add-template': typeof DashboardFantasyContestTemplateAddTemplateRouteRouteWithChildren
  '/dashboard/fantasy/fixture/contest-winner-management-v2': typeof DashboardFantasyFixtureContestWinnerManagementV2RouteRouteWithChildren
  '/dashboard/brand/add-brand/add-brand-props': typeof DashboardBrandAddBrandAddBrandPropsRoute
  '/dashboard/category/add-category/category-image': typeof DashboardCategoryAddCategoryCategoryImageRoute
  '/dashboard/fantasy/contest-template/details': typeof DashboardFantasyContestTemplateDetailsRoute
  '/dashboard/fantasy/fixture/choose-from-template': typeof DashboardFantasyFixtureChooseFromTemplateRoute
  '/dashboard/fantasy/fixture/contest-category': typeof DashboardFantasyFixtureContestCategoryRoute
  '/dashboard/fantasy/fixture/contest-template-details': typeof DashboardFantasyFixtureContestTemplateDetailsRoute
  '/dashboard/fantasy/fixture/fixture-team-management': typeof DashboardFantasyFixtureFixtureTeamManagementRoute
  '/dashboard/fantasy/league-management/add-tour': typeof DashboardFantasyLeagueManagementAddTourRoute
  '/dashboard/horizon/topics/$id': typeof DashboardHorizonTopicsIdRoute
  '/dashboard/leaderboard/clone/$id': typeof DashboardLeaderboardCloneIdRoute
  '/dashboard/product/combo/$id': typeof DashboardProductComboIdRoute
  '/dashboard/promoters/requests/$requestId': typeof DashboardPromotersRequestsRequestIdRoute
  '/dashboard/promoters/verification/$verificationId': typeof DashboardPromotersVerificationVerificationIdRoute
  '/dashboard/promoters/withdraw-request/$withdrawalId': typeof DashboardPromotersWithdrawRequestWithdrawalIdRoute
  '/dashboard/support/manage-user/aviator-history': typeof DashboardSupportManageUserAviatorHistoryRoute
  '/dashboard/support/manage-user/fantasy-history': typeof DashboardSupportManageUserFantasyHistoryRoute
  '/dashboard/support/manage-user/gameplay-history': typeof DashboardSupportManageUserGameplayHistoryRoute
  '/dashboard/support/manage-user/order-history': typeof DashboardSupportManageUserOrderHistoryRoute
  '/dashboard/support/manage-user/transaction': typeof DashboardSupportManageUserTransactionRoute
  '/dashboard/brand/add-brand/': typeof DashboardBrandAddBrandIndexRoute
  '/dashboard/category/add-category/': typeof DashboardCategoryAddCategoryIndexRoute
  '/dashboard/fantasy/contest-template/': typeof DashboardFantasyContestTemplateIndexRoute
  '/dashboard/fantasy/create-contest/': typeof DashboardFantasyCreateContestIndexRoute
  '/dashboard/fantasy/fixture/': typeof DashboardFantasyFixtureIndexRoute
  '/dashboard/fantasy/home-management/': typeof DashboardFantasyHomeManagementIndexRoute
  '/dashboard/fantasy/league-management/': typeof DashboardFantasyLeagueManagementIndexRoute
  '/dashboard/fantasy/teams/': typeof DashboardFantasyTeamsIndexRoute
  '/dashboard/horizon/categories/': typeof DashboardHorizonCategoriesIndexRoute
  '/dashboard/horizon/event-templates/': typeof DashboardHorizonEventTemplatesIndexRoute
  '/dashboard/horizon/topics/': typeof DashboardHorizonTopicsIndexRoute
  '/dashboard/product/add-product/': typeof DashboardProductAddProductIndexRoute
  '/dashboard/product/combo/': typeof DashboardProductComboIndexRoute
  '/dashboard/promoters/requests/': typeof DashboardPromotersRequestsIndexRoute
  '/dashboard/promoters/verification/': typeof DashboardPromotersVerificationIndexRoute
  '/dashboard/promoters/withdraw-request/': typeof DashboardPromotersWithdrawRequestIndexRoute
  '/dashboard/fantasy/fixture/contest-details/user-players': typeof DashboardFantasyFixtureContestDetailsUserPlayersRoute
  '/dashboard/fantasy/contest-template/add-template/': typeof DashboardFantasyContestTemplateAddTemplateIndexRoute
  '/dashboard/fantasy/fixture/contest-details/': typeof DashboardFantasyFixtureContestDetailsIndexRoute
  '/dashboard/fantasy/fixture/contest-winner-management-v2/': typeof DashboardFantasyFixtureContestWinnerManagementV2IndexRoute
  '/dashboard/fantasy/fixture/contest-winner-management/': typeof DashboardFantasyFixtureContestWinnerManagementIndexRoute
  '/dashboard/horizon/event-templates/requests/': typeof DashboardHorizonEventTemplatesRequestsIndexRoute
  '/dashboard/product/add-product/sale-settings/': typeof DashboardProductAddProductSaleSettingsIndexRoute
  '/dashboard/product/combo/add-combination/': typeof DashboardProductComboAddCombinationIndexRoute
  '/dashboard/product/add-product/sale-settings/product-settings/invoice-details': typeof DashboardProductAddProductSaleSettingsProductSettingsInvoiceDetailsRoute
  '/dashboard/product/add-product/sale-settings/product-settings/': typeof DashboardProductAddProductSaleSettingsProductSettingsIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/dashboard'
    | '/login'
    | '/logout'
    | '/dashboard/admin-action'
    | '/dashboard/apk-management'
    | '/dashboard/banner'
    | '/dashboard/bulk-operation'
    | '/dashboard/cancel-order'
    | '/dashboard/failed-orders'
    | '/dashboard/merchandise'
    | '/dashboard/novo-sell-retry'
    | '/dashboard/orders'
    | '/dashboard/promoter'
    | '/dashboard/risk-check'
    | '/dashboard/'
    | '/dashboard/fantasy/create-contest'
    | '/admin/auth/success'
    | '/dashboard/banner-management/$bannerId'
    | '/dashboard/banner-management/new'
    | '/dashboard/companies/$id'
    | '/dashboard/companies/add'
    | '/dashboard/fantasy/contest-group'
    | '/dashboard/fantasy/players'
    | '/dashboard/leaderboard/$id'
    | '/dashboard/leaderboard/add'
    | '/dashboard/product/$id'
    | '/dashboard/product/manage-voucher'
    | '/dashboard/product/track-order'
    | '/dashboard/promoters/$promoterId'
    | '/dashboard/support/escalate-issue'
    | '/dashboard/support/manage-user'
    | '/dashboard/support/push-notification'
    | '/dashboard/admin-approvals'
    | '/dashboard/admin-logs'
    | '/dashboard/banner-management'
    | '/dashboard/brand'
    | '/dashboard/category'
    | '/dashboard/companies'
    | '/dashboard/fantasy'
    | '/dashboard/horizon'
    | '/dashboard/leaderboard'
    | '/dashboard/maintenance'
    | '/dashboard/master-control'
    | '/dashboard/product'
    | '/dashboard/promoters'
    | '/dashboard/fantasy/contest-template/add-template'
    | '/dashboard/fantasy/fixture/contest-winner-management-v2'
    | '/dashboard/brand/add-brand/add-brand-props'
    | '/dashboard/category/add-category/category-image'
    | '/dashboard/fantasy/contest-template/details'
    | '/dashboard/fantasy/fixture/choose-from-template'
    | '/dashboard/fantasy/fixture/contest-category'
    | '/dashboard/fantasy/fixture/contest-template-details'
    | '/dashboard/fantasy/fixture/fixture-team-management'
    | '/dashboard/fantasy/league-management/add-tour'
    | '/dashboard/horizon/topics/$id'
    | '/dashboard/leaderboard/clone/$id'
    | '/dashboard/product/combo/$id'
    | '/dashboard/promoters/requests/$requestId'
    | '/dashboard/promoters/verification/$verificationId'
    | '/dashboard/promoters/withdraw-request/$withdrawalId'
    | '/dashboard/support/manage-user/aviator-history'
    | '/dashboard/support/manage-user/fantasy-history'
    | '/dashboard/support/manage-user/gameplay-history'
    | '/dashboard/support/manage-user/order-history'
    | '/dashboard/support/manage-user/transaction'
    | '/dashboard/brand/add-brand'
    | '/dashboard/category/add-category'
    | '/dashboard/fantasy/contest-template'
    | '/dashboard/fantasy/create-contest/'
    | '/dashboard/fantasy/fixture'
    | '/dashboard/fantasy/home-management'
    | '/dashboard/fantasy/league-management'
    | '/dashboard/fantasy/teams'
    | '/dashboard/horizon/categories'
    | '/dashboard/horizon/event-templates'
    | '/dashboard/horizon/topics'
    | '/dashboard/product/add-product'
    | '/dashboard/product/combo'
    | '/dashboard/promoters/requests'
    | '/dashboard/promoters/verification'
    | '/dashboard/promoters/withdraw-request'
    | '/dashboard/fantasy/fixture/contest-details/user-players'
    | '/dashboard/fantasy/contest-template/add-template/'
    | '/dashboard/fantasy/fixture/contest-details'
    | '/dashboard/fantasy/fixture/contest-winner-management-v2/'
    | '/dashboard/fantasy/fixture/contest-winner-management'
    | '/dashboard/horizon/event-templates/requests'
    | '/dashboard/product/add-product/sale-settings'
    | '/dashboard/product/combo/add-combination'
    | '/dashboard/product/add-product/sale-settings/product-settings/invoice-details'
    | '/dashboard/product/add-product/sale-settings/product-settings'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/login'
    | '/logout'
    | '/dashboard/admin-action'
    | '/dashboard/apk-management'
    | '/dashboard/banner'
    | '/dashboard/bulk-operation'
    | '/dashboard/cancel-order'
    | '/dashboard/failed-orders'
    | '/dashboard/merchandise'
    | '/dashboard/novo-sell-retry'
    | '/dashboard/orders'
    | '/dashboard/promoter'
    | '/dashboard/risk-check'
    | '/dashboard'
    | '/admin/auth/success'
    | '/dashboard/banner-management/$bannerId'
    | '/dashboard/banner-management/new'
    | '/dashboard/companies/$id'
    | '/dashboard/companies/add'
    | '/dashboard/fantasy/contest-group'
    | '/dashboard/fantasy/players'
    | '/dashboard/leaderboard/$id'
    | '/dashboard/leaderboard/add'
    | '/dashboard/product/$id'
    | '/dashboard/product/manage-voucher'
    | '/dashboard/product/track-order'
    | '/dashboard/promoters/$promoterId'
    | '/dashboard/support/escalate-issue'
    | '/dashboard/support/manage-user'
    | '/dashboard/support/push-notification'
    | '/dashboard/admin-approvals'
    | '/dashboard/admin-logs'
    | '/dashboard/banner-management'
    | '/dashboard/brand'
    | '/dashboard/category'
    | '/dashboard/companies'
    | '/dashboard/fantasy'
    | '/dashboard/horizon'
    | '/dashboard/leaderboard'
    | '/dashboard/maintenance'
    | '/dashboard/master-control'
    | '/dashboard/product'
    | '/dashboard/promoters'
    | '/dashboard/brand/add-brand/add-brand-props'
    | '/dashboard/category/add-category/category-image'
    | '/dashboard/fantasy/contest-template/details'
    | '/dashboard/fantasy/fixture/choose-from-template'
    | '/dashboard/fantasy/fixture/contest-category'
    | '/dashboard/fantasy/fixture/contest-template-details'
    | '/dashboard/fantasy/fixture/fixture-team-management'
    | '/dashboard/fantasy/league-management/add-tour'
    | '/dashboard/horizon/topics/$id'
    | '/dashboard/leaderboard/clone/$id'
    | '/dashboard/product/combo/$id'
    | '/dashboard/promoters/requests/$requestId'
    | '/dashboard/promoters/verification/$verificationId'
    | '/dashboard/promoters/withdraw-request/$withdrawalId'
    | '/dashboard/support/manage-user/aviator-history'
    | '/dashboard/support/manage-user/fantasy-history'
    | '/dashboard/support/manage-user/gameplay-history'
    | '/dashboard/support/manage-user/order-history'
    | '/dashboard/support/manage-user/transaction'
    | '/dashboard/brand/add-brand'
    | '/dashboard/category/add-category'
    | '/dashboard/fantasy/contest-template'
    | '/dashboard/fantasy/create-contest'
    | '/dashboard/fantasy/fixture'
    | '/dashboard/fantasy/home-management'
    | '/dashboard/fantasy/league-management'
    | '/dashboard/fantasy/teams'
    | '/dashboard/horizon/categories'
    | '/dashboard/horizon/event-templates'
    | '/dashboard/horizon/topics'
    | '/dashboard/product/add-product'
    | '/dashboard/product/combo'
    | '/dashboard/promoters/requests'
    | '/dashboard/promoters/verification'
    | '/dashboard/promoters/withdraw-request'
    | '/dashboard/fantasy/fixture/contest-details/user-players'
    | '/dashboard/fantasy/contest-template/add-template'
    | '/dashboard/fantasy/fixture/contest-details'
    | '/dashboard/fantasy/fixture/contest-winner-management-v2'
    | '/dashboard/fantasy/fixture/contest-winner-management'
    | '/dashboard/horizon/event-templates/requests'
    | '/dashboard/product/add-product/sale-settings'
    | '/dashboard/product/combo/add-combination'
    | '/dashboard/product/add-product/sale-settings/product-settings/invoice-details'
    | '/dashboard/product/add-product/sale-settings/product-settings'
  id:
    | '__root__'
    | '/'
    | '/dashboard'
    | '/login'
    | '/logout'
    | '/dashboard/admin-action'
    | '/dashboard/apk-management'
    | '/dashboard/banner'
    | '/dashboard/bulk-operation'
    | '/dashboard/cancel-order'
    | '/dashboard/failed-orders'
    | '/dashboard/merchandise'
    | '/dashboard/novo-sell-retry'
    | '/dashboard/orders'
    | '/dashboard/promoter'
    | '/dashboard/risk-check'
    | '/dashboard/'
    | '/dashboard/fantasy/create-contest'
    | '/admin/auth/success'
    | '/dashboard/banner-management/$bannerId'
    | '/dashboard/banner-management/new'
    | '/dashboard/companies/$id'
    | '/dashboard/companies/add'
    | '/dashboard/fantasy/contest-group'
    | '/dashboard/fantasy/players'
    | '/dashboard/leaderboard/$id'
    | '/dashboard/leaderboard/add'
    | '/dashboard/product/$id'
    | '/dashboard/product/manage-voucher'
    | '/dashboard/product/track-order'
    | '/dashboard/promoters/$promoterId'
    | '/dashboard/support/escalate-issue'
    | '/dashboard/support/manage-user'
    | '/dashboard/support/push-notification'
    | '/dashboard/admin-approvals/'
    | '/dashboard/admin-logs/'
    | '/dashboard/banner-management/'
    | '/dashboard/brand/'
    | '/dashboard/category/'
    | '/dashboard/companies/'
    | '/dashboard/fantasy/'
    | '/dashboard/horizon/'
    | '/dashboard/leaderboard/'
    | '/dashboard/maintenance/'
    | '/dashboard/master-control/'
    | '/dashboard/product/'
    | '/dashboard/promoters/'
    | '/dashboard/fantasy/contest-template/add-template'
    | '/dashboard/fantasy/fixture/contest-winner-management-v2'
    | '/dashboard/brand/add-brand/add-brand-props'
    | '/dashboard/category/add-category/category-image'
    | '/dashboard/fantasy/contest-template/details'
    | '/dashboard/fantasy/fixture/choose-from-template'
    | '/dashboard/fantasy/fixture/contest-category'
    | '/dashboard/fantasy/fixture/contest-template-details'
    | '/dashboard/fantasy/fixture/fixture-team-management'
    | '/dashboard/fantasy/league-management/add-tour'
    | '/dashboard/horizon/topics/$id'
    | '/dashboard/leaderboard/clone/$id'
    | '/dashboard/product/combo/$id'
    | '/dashboard/promoters/requests/$requestId'
    | '/dashboard/promoters/verification/$verificationId'
    | '/dashboard/promoters/withdraw-request/$withdrawalId'
    | '/dashboard/support/manage-user/aviator-history'
    | '/dashboard/support/manage-user/fantasy-history'
    | '/dashboard/support/manage-user/gameplay-history'
    | '/dashboard/support/manage-user/order-history'
    | '/dashboard/support/manage-user/transaction'
    | '/dashboard/brand/add-brand/'
    | '/dashboard/category/add-category/'
    | '/dashboard/fantasy/contest-template/'
    | '/dashboard/fantasy/create-contest/'
    | '/dashboard/fantasy/fixture/'
    | '/dashboard/fantasy/home-management/'
    | '/dashboard/fantasy/league-management/'
    | '/dashboard/fantasy/teams/'
    | '/dashboard/horizon/categories/'
    | '/dashboard/horizon/event-templates/'
    | '/dashboard/horizon/topics/'
    | '/dashboard/product/add-product/'
    | '/dashboard/product/combo/'
    | '/dashboard/promoters/requests/'
    | '/dashboard/promoters/verification/'
    | '/dashboard/promoters/withdraw-request/'
    | '/dashboard/fantasy/fixture/contest-details/user-players'
    | '/dashboard/fantasy/contest-template/add-template/'
    | '/dashboard/fantasy/fixture/contest-details/'
    | '/dashboard/fantasy/fixture/contest-winner-management-v2/'
    | '/dashboard/fantasy/fixture/contest-winner-management/'
    | '/dashboard/horizon/event-templates/requests/'
    | '/dashboard/product/add-product/sale-settings/'
    | '/dashboard/product/combo/add-combination/'
    | '/dashboard/product/add-product/sale-settings/product-settings/invoice-details'
    | '/dashboard/product/add-product/sale-settings/product-settings/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  DashboardRouteRoute: typeof DashboardRouteRouteWithChildren
  LoginRoute: typeof LoginRoute
  LogoutRoute: typeof LogoutRoute
  AdminAuthSuccessRoute: typeof AdminAuthSuccessRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/logout': {
      id: '/logout'
      path: '/logout'
      fullPath: '/logout'
      preLoaderRoute: typeof LogoutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dashboard': {
      id: '/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof DashboardRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dashboard/': {
      id: '/dashboard/'
      path: '/'
      fullPath: '/dashboard/'
      preLoaderRoute: typeof DashboardIndexRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/dashboard/risk-check': {
      id: '/dashboard/risk-check'
      path: '/risk-check'
      fullPath: '/dashboard/risk-check'
      preLoaderRoute: typeof DashboardRiskCheckRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/dashboard/promoter': {
      id: '/dashboard/promoter'
      path: '/promoter'
      fullPath: '/dashboard/promoter'
      preLoaderRoute: typeof DashboardPromoterRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/dashboard/orders': {
      id: '/dashboard/orders'
      path: '/orders'
      fullPath: '/dashboard/orders'
      preLoaderRoute: typeof DashboardOrdersRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/dashboard/novo-sell-retry': {
      id: '/dashboard/novo-sell-retry'
      path: '/novo-sell-retry'
      fullPath: '/dashboard/novo-sell-retry'
      preLoaderRoute: typeof DashboardNovoSellRetryRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/dashboard/merchandise': {
      id: '/dashboard/merchandise'
      path: '/merchandise'
      fullPath: '/dashboard/merchandise'
      preLoaderRoute: typeof DashboardMerchandiseRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/dashboard/failed-orders': {
      id: '/dashboard/failed-orders'
      path: '/failed-orders'
      fullPath: '/dashboard/failed-orders'
      preLoaderRoute: typeof DashboardFailedOrdersRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/dashboard/cancel-order': {
      id: '/dashboard/cancel-order'
      path: '/cancel-order'
      fullPath: '/dashboard/cancel-order'
      preLoaderRoute: typeof DashboardCancelOrderRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/dashboard/bulk-operation': {
      id: '/dashboard/bulk-operation'
      path: '/bulk-operation'
      fullPath: '/dashboard/bulk-operation'
      preLoaderRoute: typeof DashboardBulkOperationRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/dashboard/banner': {
      id: '/dashboard/banner'
      path: '/banner'
      fullPath: '/dashboard/banner'
      preLoaderRoute: typeof DashboardBannerRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/dashboard/apk-management': {
      id: '/dashboard/apk-management'
      path: '/apk-management'
      fullPath: '/dashboard/apk-management'
      preLoaderRoute: typeof DashboardApkManagementRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/dashboard/admin-action': {
      id: '/dashboard/admin-action'
      path: '/admin-action'
      fullPath: '/dashboard/admin-action'
      preLoaderRoute: typeof DashboardAdminActionRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/dashboard/promoters/': {
      id: '/dashboard/promoters/'
      path: '/promoters'
      fullPath: '/dashboard/promoters'
      preLoaderRoute: typeof DashboardPromotersIndexRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/dashboard/product/': {
      id: '/dashboard/product/'
      path: '/product'
      fullPath: '/dashboard/product'
      preLoaderRoute: typeof DashboardProductIndexRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/dashboard/master-control/': {
      id: '/dashboard/master-control/'
      path: '/master-control'
      fullPath: '/dashboard/master-control'
      preLoaderRoute: typeof DashboardMasterControlIndexRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/dashboard/maintenance/': {
      id: '/dashboard/maintenance/'
      path: '/maintenance'
      fullPath: '/dashboard/maintenance'
      preLoaderRoute: typeof DashboardMaintenanceIndexRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/dashboard/leaderboard/': {
      id: '/dashboard/leaderboard/'
      path: '/leaderboard'
      fullPath: '/dashboard/leaderboard'
      preLoaderRoute: typeof DashboardLeaderboardIndexRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/dashboard/horizon/': {
      id: '/dashboard/horizon/'
      path: '/horizon'
      fullPath: '/dashboard/horizon'
      preLoaderRoute: typeof DashboardHorizonIndexRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/dashboard/fantasy/': {
      id: '/dashboard/fantasy/'
      path: '/fantasy'
      fullPath: '/dashboard/fantasy'
      preLoaderRoute: typeof DashboardFantasyIndexRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/dashboard/companies/': {
      id: '/dashboard/companies/'
      path: '/companies'
      fullPath: '/dashboard/companies'
      preLoaderRoute: typeof DashboardCompaniesIndexRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/dashboard/category/': {
      id: '/dashboard/category/'
      path: '/category'
      fullPath: '/dashboard/category'
      preLoaderRoute: typeof DashboardCategoryIndexRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/dashboard/brand/': {
      id: '/dashboard/brand/'
      path: '/brand'
      fullPath: '/dashboard/brand'
      preLoaderRoute: typeof DashboardBrandIndexRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/dashboard/banner-management/': {
      id: '/dashboard/banner-management/'
      path: '/banner-management'
      fullPath: '/dashboard/banner-management'
      preLoaderRoute: typeof DashboardBannerManagementIndexRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/dashboard/admin-logs/': {
      id: '/dashboard/admin-logs/'
      path: '/admin-logs'
      fullPath: '/dashboard/admin-logs'
      preLoaderRoute: typeof DashboardAdminLogsIndexRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/dashboard/admin-approvals/': {
      id: '/dashboard/admin-approvals/'
      path: '/admin-approvals'
      fullPath: '/dashboard/admin-approvals'
      preLoaderRoute: typeof DashboardAdminApprovalsIndexRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/dashboard/support/push-notification': {
      id: '/dashboard/support/push-notification'
      path: '/support/push-notification'
      fullPath: '/dashboard/support/push-notification'
      preLoaderRoute: typeof DashboardSupportPushNotificationRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/dashboard/support/manage-user': {
      id: '/dashboard/support/manage-user'
      path: '/support/manage-user'
      fullPath: '/dashboard/support/manage-user'
      preLoaderRoute: typeof DashboardSupportManageUserRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/dashboard/support/escalate-issue': {
      id: '/dashboard/support/escalate-issue'
      path: '/support/escalate-issue'
      fullPath: '/dashboard/support/escalate-issue'
      preLoaderRoute: typeof DashboardSupportEscalateIssueRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/dashboard/promoters/$promoterId': {
      id: '/dashboard/promoters/$promoterId'
      path: '/promoters/$promoterId'
      fullPath: '/dashboard/promoters/$promoterId'
      preLoaderRoute: typeof DashboardPromotersPromoterIdRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/dashboard/product/track-order': {
      id: '/dashboard/product/track-order'
      path: '/product/track-order'
      fullPath: '/dashboard/product/track-order'
      preLoaderRoute: typeof DashboardProductTrackOrderRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/dashboard/product/manage-voucher': {
      id: '/dashboard/product/manage-voucher'
      path: '/product/manage-voucher'
      fullPath: '/dashboard/product/manage-voucher'
      preLoaderRoute: typeof DashboardProductManageVoucherRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/dashboard/product/$id': {
      id: '/dashboard/product/$id'
      path: '/product/$id'
      fullPath: '/dashboard/product/$id'
      preLoaderRoute: typeof DashboardProductIdRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/dashboard/leaderboard/add': {
      id: '/dashboard/leaderboard/add'
      path: '/leaderboard/add'
      fullPath: '/dashboard/leaderboard/add'
      preLoaderRoute: typeof DashboardLeaderboardAddRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/dashboard/leaderboard/$id': {
      id: '/dashboard/leaderboard/$id'
      path: '/leaderboard/$id'
      fullPath: '/dashboard/leaderboard/$id'
      preLoaderRoute: typeof DashboardLeaderboardIdRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/dashboard/fantasy/players': {
      id: '/dashboard/fantasy/players'
      path: '/fantasy/players'
      fullPath: '/dashboard/fantasy/players'
      preLoaderRoute: typeof DashboardFantasyPlayersRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/dashboard/fantasy/contest-group': {
      id: '/dashboard/fantasy/contest-group'
      path: '/fantasy/contest-group'
      fullPath: '/dashboard/fantasy/contest-group'
      preLoaderRoute: typeof DashboardFantasyContestGroupRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/dashboard/companies/add': {
      id: '/dashboard/companies/add'
      path: '/companies/add'
      fullPath: '/dashboard/companies/add'
      preLoaderRoute: typeof DashboardCompaniesAddRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/dashboard/companies/$id': {
      id: '/dashboard/companies/$id'
      path: '/companies/$id'
      fullPath: '/dashboard/companies/$id'
      preLoaderRoute: typeof DashboardCompaniesIdRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/dashboard/banner-management/new': {
      id: '/dashboard/banner-management/new'
      path: '/banner-management/new'
      fullPath: '/dashboard/banner-management/new'
      preLoaderRoute: typeof DashboardBannerManagementNewRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/dashboard/banner-management/$bannerId': {
      id: '/dashboard/banner-management/$bannerId'
      path: '/banner-management/$bannerId'
      fullPath: '/dashboard/banner-management/$bannerId'
      preLoaderRoute: typeof DashboardBannerManagementBannerIdRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/admin/auth/success': {
      id: '/admin/auth/success'
      path: '/admin/auth/success'
      fullPath: '/admin/auth/success'
      preLoaderRoute: typeof AdminAuthSuccessRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dashboard/fantasy/create-contest': {
      id: '/dashboard/fantasy/create-contest'
      path: '/fantasy/create-contest'
      fullPath: '/dashboard/fantasy/create-contest'
      preLoaderRoute: typeof DashboardFantasyCreateContestRouteRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/dashboard/promoters/withdraw-request/': {
      id: '/dashboard/promoters/withdraw-request/'
      path: '/promoters/withdraw-request'
      fullPath: '/dashboard/promoters/withdraw-request'
      preLoaderRoute: typeof DashboardPromotersWithdrawRequestIndexRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/dashboard/promoters/verification/': {
      id: '/dashboard/promoters/verification/'
      path: '/promoters/verification'
      fullPath: '/dashboard/promoters/verification'
      preLoaderRoute: typeof DashboardPromotersVerificationIndexRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/dashboard/promoters/requests/': {
      id: '/dashboard/promoters/requests/'
      path: '/promoters/requests'
      fullPath: '/dashboard/promoters/requests'
      preLoaderRoute: typeof DashboardPromotersRequestsIndexRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/dashboard/product/combo/': {
      id: '/dashboard/product/combo/'
      path: '/product/combo'
      fullPath: '/dashboard/product/combo'
      preLoaderRoute: typeof DashboardProductComboIndexRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/dashboard/product/add-product/': {
      id: '/dashboard/product/add-product/'
      path: '/product/add-product'
      fullPath: '/dashboard/product/add-product'
      preLoaderRoute: typeof DashboardProductAddProductIndexRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/dashboard/horizon/topics/': {
      id: '/dashboard/horizon/topics/'
      path: '/horizon/topics'
      fullPath: '/dashboard/horizon/topics'
      preLoaderRoute: typeof DashboardHorizonTopicsIndexRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/dashboard/horizon/event-templates/': {
      id: '/dashboard/horizon/event-templates/'
      path: '/horizon/event-templates'
      fullPath: '/dashboard/horizon/event-templates'
      preLoaderRoute: typeof DashboardHorizonEventTemplatesIndexRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/dashboard/horizon/categories/': {
      id: '/dashboard/horizon/categories/'
      path: '/horizon/categories'
      fullPath: '/dashboard/horizon/categories'
      preLoaderRoute: typeof DashboardHorizonCategoriesIndexRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/dashboard/fantasy/teams/': {
      id: '/dashboard/fantasy/teams/'
      path: '/fantasy/teams'
      fullPath: '/dashboard/fantasy/teams'
      preLoaderRoute: typeof DashboardFantasyTeamsIndexRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/dashboard/fantasy/league-management/': {
      id: '/dashboard/fantasy/league-management/'
      path: '/fantasy/league-management'
      fullPath: '/dashboard/fantasy/league-management'
      preLoaderRoute: typeof DashboardFantasyLeagueManagementIndexRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/dashboard/fantasy/home-management/': {
      id: '/dashboard/fantasy/home-management/'
      path: '/fantasy/home-management'
      fullPath: '/dashboard/fantasy/home-management'
      preLoaderRoute: typeof DashboardFantasyHomeManagementIndexRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/dashboard/fantasy/fixture/': {
      id: '/dashboard/fantasy/fixture/'
      path: '/fantasy/fixture'
      fullPath: '/dashboard/fantasy/fixture'
      preLoaderRoute: typeof DashboardFantasyFixtureIndexRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/dashboard/fantasy/create-contest/': {
      id: '/dashboard/fantasy/create-contest/'
      path: '/'
      fullPath: '/dashboard/fantasy/create-contest/'
      preLoaderRoute: typeof DashboardFantasyCreateContestIndexRouteImport
      parentRoute: typeof DashboardFantasyCreateContestRouteRoute
    }
    '/dashboard/fantasy/contest-template/': {
      id: '/dashboard/fantasy/contest-template/'
      path: '/fantasy/contest-template'
      fullPath: '/dashboard/fantasy/contest-template'
      preLoaderRoute: typeof DashboardFantasyContestTemplateIndexRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/dashboard/category/add-category/': {
      id: '/dashboard/category/add-category/'
      path: '/category/add-category'
      fullPath: '/dashboard/category/add-category'
      preLoaderRoute: typeof DashboardCategoryAddCategoryIndexRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/dashboard/brand/add-brand/': {
      id: '/dashboard/brand/add-brand/'
      path: '/brand/add-brand'
      fullPath: '/dashboard/brand/add-brand'
      preLoaderRoute: typeof DashboardBrandAddBrandIndexRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/dashboard/support/manage-user/transaction': {
      id: '/dashboard/support/manage-user/transaction'
      path: '/transaction'
      fullPath: '/dashboard/support/manage-user/transaction'
      preLoaderRoute: typeof DashboardSupportManageUserTransactionRouteImport
      parentRoute: typeof DashboardSupportManageUserRoute
    }
    '/dashboard/support/manage-user/order-history': {
      id: '/dashboard/support/manage-user/order-history'
      path: '/order-history'
      fullPath: '/dashboard/support/manage-user/order-history'
      preLoaderRoute: typeof DashboardSupportManageUserOrderHistoryRouteImport
      parentRoute: typeof DashboardSupportManageUserRoute
    }
    '/dashboard/support/manage-user/gameplay-history': {
      id: '/dashboard/support/manage-user/gameplay-history'
      path: '/gameplay-history'
      fullPath: '/dashboard/support/manage-user/gameplay-history'
      preLoaderRoute: typeof DashboardSupportManageUserGameplayHistoryRouteImport
      parentRoute: typeof DashboardSupportManageUserRoute
    }
    '/dashboard/support/manage-user/fantasy-history': {
      id: '/dashboard/support/manage-user/fantasy-history'
      path: '/fantasy-history'
      fullPath: '/dashboard/support/manage-user/fantasy-history'
      preLoaderRoute: typeof DashboardSupportManageUserFantasyHistoryRouteImport
      parentRoute: typeof DashboardSupportManageUserRoute
    }
    '/dashboard/support/manage-user/aviator-history': {
      id: '/dashboard/support/manage-user/aviator-history'
      path: '/aviator-history'
      fullPath: '/dashboard/support/manage-user/aviator-history'
      preLoaderRoute: typeof DashboardSupportManageUserAviatorHistoryRouteImport
      parentRoute: typeof DashboardSupportManageUserRoute
    }
    '/dashboard/promoters/withdraw-request/$withdrawalId': {
      id: '/dashboard/promoters/withdraw-request/$withdrawalId'
      path: '/promoters/withdraw-request/$withdrawalId'
      fullPath: '/dashboard/promoters/withdraw-request/$withdrawalId'
      preLoaderRoute: typeof DashboardPromotersWithdrawRequestWithdrawalIdRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/dashboard/promoters/verification/$verificationId': {
      id: '/dashboard/promoters/verification/$verificationId'
      path: '/promoters/verification/$verificationId'
      fullPath: '/dashboard/promoters/verification/$verificationId'
      preLoaderRoute: typeof DashboardPromotersVerificationVerificationIdRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/dashboard/promoters/requests/$requestId': {
      id: '/dashboard/promoters/requests/$requestId'
      path: '/promoters/requests/$requestId'
      fullPath: '/dashboard/promoters/requests/$requestId'
      preLoaderRoute: typeof DashboardPromotersRequestsRequestIdRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/dashboard/product/combo/$id': {
      id: '/dashboard/product/combo/$id'
      path: '/product/combo/$id'
      fullPath: '/dashboard/product/combo/$id'
      preLoaderRoute: typeof DashboardProductComboIdRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/dashboard/leaderboard/clone/$id': {
      id: '/dashboard/leaderboard/clone/$id'
      path: '/leaderboard/clone/$id'
      fullPath: '/dashboard/leaderboard/clone/$id'
      preLoaderRoute: typeof DashboardLeaderboardCloneIdRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/dashboard/horizon/topics/$id': {
      id: '/dashboard/horizon/topics/$id'
      path: '/horizon/topics/$id'
      fullPath: '/dashboard/horizon/topics/$id'
      preLoaderRoute: typeof DashboardHorizonTopicsIdRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/dashboard/fantasy/league-management/add-tour': {
      id: '/dashboard/fantasy/league-management/add-tour'
      path: '/fantasy/league-management/add-tour'
      fullPath: '/dashboard/fantasy/league-management/add-tour'
      preLoaderRoute: typeof DashboardFantasyLeagueManagementAddTourRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/dashboard/fantasy/fixture/fixture-team-management': {
      id: '/dashboard/fantasy/fixture/fixture-team-management'
      path: '/fantasy/fixture/fixture-team-management'
      fullPath: '/dashboard/fantasy/fixture/fixture-team-management'
      preLoaderRoute: typeof DashboardFantasyFixtureFixtureTeamManagementRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/dashboard/fantasy/fixture/contest-template-details': {
      id: '/dashboard/fantasy/fixture/contest-template-details'
      path: '/fantasy/fixture/contest-template-details'
      fullPath: '/dashboard/fantasy/fixture/contest-template-details'
      preLoaderRoute: typeof DashboardFantasyFixtureContestTemplateDetailsRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/dashboard/fantasy/fixture/contest-category': {
      id: '/dashboard/fantasy/fixture/contest-category'
      path: '/fantasy/fixture/contest-category'
      fullPath: '/dashboard/fantasy/fixture/contest-category'
      preLoaderRoute: typeof DashboardFantasyFixtureContestCategoryRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/dashboard/fantasy/fixture/choose-from-template': {
      id: '/dashboard/fantasy/fixture/choose-from-template'
      path: '/fantasy/fixture/choose-from-template'
      fullPath: '/dashboard/fantasy/fixture/choose-from-template'
      preLoaderRoute: typeof DashboardFantasyFixtureChooseFromTemplateRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/dashboard/fantasy/contest-template/details': {
      id: '/dashboard/fantasy/contest-template/details'
      path: '/fantasy/contest-template/details'
      fullPath: '/dashboard/fantasy/contest-template/details'
      preLoaderRoute: typeof DashboardFantasyContestTemplateDetailsRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/dashboard/category/add-category/category-image': {
      id: '/dashboard/category/add-category/category-image'
      path: '/category/add-category/category-image'
      fullPath: '/dashboard/category/add-category/category-image'
      preLoaderRoute: typeof DashboardCategoryAddCategoryCategoryImageRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/dashboard/brand/add-brand/add-brand-props': {
      id: '/dashboard/brand/add-brand/add-brand-props'
      path: '/brand/add-brand/add-brand-props'
      fullPath: '/dashboard/brand/add-brand/add-brand-props'
      preLoaderRoute: typeof DashboardBrandAddBrandAddBrandPropsRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/dashboard/fantasy/fixture/contest-winner-management-v2': {
      id: '/dashboard/fantasy/fixture/contest-winner-management-v2'
      path: '/fantasy/fixture/contest-winner-management-v2'
      fullPath: '/dashboard/fantasy/fixture/contest-winner-management-v2'
      preLoaderRoute: typeof DashboardFantasyFixtureContestWinnerManagementV2RouteRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/dashboard/fantasy/contest-template/add-template': {
      id: '/dashboard/fantasy/contest-template/add-template'
      path: '/fantasy/contest-template/add-template'
      fullPath: '/dashboard/fantasy/contest-template/add-template'
      preLoaderRoute: typeof DashboardFantasyContestTemplateAddTemplateRouteRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/dashboard/product/combo/add-combination/': {
      id: '/dashboard/product/combo/add-combination/'
      path: '/product/combo/add-combination'
      fullPath: '/dashboard/product/combo/add-combination'
      preLoaderRoute: typeof DashboardProductComboAddCombinationIndexRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/dashboard/product/add-product/sale-settings/': {
      id: '/dashboard/product/add-product/sale-settings/'
      path: '/product/add-product/sale-settings'
      fullPath: '/dashboard/product/add-product/sale-settings'
      preLoaderRoute: typeof DashboardProductAddProductSaleSettingsIndexRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/dashboard/horizon/event-templates/requests/': {
      id: '/dashboard/horizon/event-templates/requests/'
      path: '/horizon/event-templates/requests'
      fullPath: '/dashboard/horizon/event-templates/requests'
      preLoaderRoute: typeof DashboardHorizonEventTemplatesRequestsIndexRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/dashboard/fantasy/fixture/contest-winner-management/': {
      id: '/dashboard/fantasy/fixture/contest-winner-management/'
      path: '/fantasy/fixture/contest-winner-management'
      fullPath: '/dashboard/fantasy/fixture/contest-winner-management'
      preLoaderRoute: typeof DashboardFantasyFixtureContestWinnerManagementIndexRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/dashboard/fantasy/fixture/contest-winner-management-v2/': {
      id: '/dashboard/fantasy/fixture/contest-winner-management-v2/'
      path: '/'
      fullPath: '/dashboard/fantasy/fixture/contest-winner-management-v2/'
      preLoaderRoute: typeof DashboardFantasyFixtureContestWinnerManagementV2IndexRouteImport
      parentRoute: typeof DashboardFantasyFixtureContestWinnerManagementV2RouteRoute
    }
    '/dashboard/fantasy/fixture/contest-details/': {
      id: '/dashboard/fantasy/fixture/contest-details/'
      path: '/fantasy/fixture/contest-details'
      fullPath: '/dashboard/fantasy/fixture/contest-details'
      preLoaderRoute: typeof DashboardFantasyFixtureContestDetailsIndexRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/dashboard/fantasy/contest-template/add-template/': {
      id: '/dashboard/fantasy/contest-template/add-template/'
      path: '/'
      fullPath: '/dashboard/fantasy/contest-template/add-template/'
      preLoaderRoute: typeof DashboardFantasyContestTemplateAddTemplateIndexRouteImport
      parentRoute: typeof DashboardFantasyContestTemplateAddTemplateRouteRoute
    }
    '/dashboard/fantasy/fixture/contest-details/user-players': {
      id: '/dashboard/fantasy/fixture/contest-details/user-players'
      path: '/fantasy/fixture/contest-details/user-players'
      fullPath: '/dashboard/fantasy/fixture/contest-details/user-players'
      preLoaderRoute: typeof DashboardFantasyFixtureContestDetailsUserPlayersRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/dashboard/product/add-product/sale-settings/product-settings/': {
      id: '/dashboard/product/add-product/sale-settings/product-settings/'
      path: '/product/add-product/sale-settings/product-settings'
      fullPath: '/dashboard/product/add-product/sale-settings/product-settings'
      preLoaderRoute: typeof DashboardProductAddProductSaleSettingsProductSettingsIndexRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/dashboard/product/add-product/sale-settings/product-settings/invoice-details': {
      id: '/dashboard/product/add-product/sale-settings/product-settings/invoice-details'
      path: '/product/add-product/sale-settings/product-settings/invoice-details'
      fullPath: '/dashboard/product/add-product/sale-settings/product-settings/invoice-details'
      preLoaderRoute: typeof DashboardProductAddProductSaleSettingsProductSettingsInvoiceDetailsRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
  }
}

interface DashboardFantasyCreateContestRouteRouteChildren {
  DashboardFantasyCreateContestIndexRoute: typeof DashboardFantasyCreateContestIndexRoute
}

const DashboardFantasyCreateContestRouteRouteChildren: DashboardFantasyCreateContestRouteRouteChildren =
  {
    DashboardFantasyCreateContestIndexRoute:
      DashboardFantasyCreateContestIndexRoute,
  }

const DashboardFantasyCreateContestRouteRouteWithChildren =
  DashboardFantasyCreateContestRouteRoute._addFileChildren(
    DashboardFantasyCreateContestRouteRouteChildren,
  )

interface DashboardSupportManageUserRouteChildren {
  DashboardSupportManageUserAviatorHistoryRoute: typeof DashboardSupportManageUserAviatorHistoryRoute
  DashboardSupportManageUserFantasyHistoryRoute: typeof DashboardSupportManageUserFantasyHistoryRoute
  DashboardSupportManageUserGameplayHistoryRoute: typeof DashboardSupportManageUserGameplayHistoryRoute
  DashboardSupportManageUserOrderHistoryRoute: typeof DashboardSupportManageUserOrderHistoryRoute
  DashboardSupportManageUserTransactionRoute: typeof DashboardSupportManageUserTransactionRoute
}

const DashboardSupportManageUserRouteChildren: DashboardSupportManageUserRouteChildren =
  {
    DashboardSupportManageUserAviatorHistoryRoute:
      DashboardSupportManageUserAviatorHistoryRoute,
    DashboardSupportManageUserFantasyHistoryRoute:
      DashboardSupportManageUserFantasyHistoryRoute,
    DashboardSupportManageUserGameplayHistoryRoute:
      DashboardSupportManageUserGameplayHistoryRoute,
    DashboardSupportManageUserOrderHistoryRoute:
      DashboardSupportManageUserOrderHistoryRoute,
    DashboardSupportManageUserTransactionRoute:
      DashboardSupportManageUserTransactionRoute,
  }

const DashboardSupportManageUserRouteWithChildren =
  DashboardSupportManageUserRoute._addFileChildren(
    DashboardSupportManageUserRouteChildren,
  )

interface DashboardFantasyContestTemplateAddTemplateRouteRouteChildren {
  DashboardFantasyContestTemplateAddTemplateIndexRoute: typeof DashboardFantasyContestTemplateAddTemplateIndexRoute
}

const DashboardFantasyContestTemplateAddTemplateRouteRouteChildren: DashboardFantasyContestTemplateAddTemplateRouteRouteChildren =
  {
    DashboardFantasyContestTemplateAddTemplateIndexRoute:
      DashboardFantasyContestTemplateAddTemplateIndexRoute,
  }

const DashboardFantasyContestTemplateAddTemplateRouteRouteWithChildren =
  DashboardFantasyContestTemplateAddTemplateRouteRoute._addFileChildren(
    DashboardFantasyContestTemplateAddTemplateRouteRouteChildren,
  )

interface DashboardFantasyFixtureContestWinnerManagementV2RouteRouteChildren {
  DashboardFantasyFixtureContestWinnerManagementV2IndexRoute: typeof DashboardFantasyFixtureContestWinnerManagementV2IndexRoute
}

const DashboardFantasyFixtureContestWinnerManagementV2RouteRouteChildren: DashboardFantasyFixtureContestWinnerManagementV2RouteRouteChildren =
  {
    DashboardFantasyFixtureContestWinnerManagementV2IndexRoute:
      DashboardFantasyFixtureContestWinnerManagementV2IndexRoute,
  }

const DashboardFantasyFixtureContestWinnerManagementV2RouteRouteWithChildren =
  DashboardFantasyFixtureContestWinnerManagementV2RouteRoute._addFileChildren(
    DashboardFantasyFixtureContestWinnerManagementV2RouteRouteChildren,
  )

interface DashboardRouteRouteChildren {
  DashboardAdminActionRoute: typeof DashboardAdminActionRoute
  DashboardApkManagementRoute: typeof DashboardApkManagementRoute
  DashboardBannerRoute: typeof DashboardBannerRoute
  DashboardBulkOperationRoute: typeof DashboardBulkOperationRoute
  DashboardCancelOrderRoute: typeof DashboardCancelOrderRoute
  DashboardFailedOrdersRoute: typeof DashboardFailedOrdersRoute
  DashboardMerchandiseRoute: typeof DashboardMerchandiseRoute
  DashboardNovoSellRetryRoute: typeof DashboardNovoSellRetryRoute
  DashboardOrdersRoute: typeof DashboardOrdersRoute
  DashboardPromoterRoute: typeof DashboardPromoterRoute
  DashboardRiskCheckRoute: typeof DashboardRiskCheckRoute
  DashboardIndexRoute: typeof DashboardIndexRoute
  DashboardFantasyCreateContestRouteRoute: typeof DashboardFantasyCreateContestRouteRouteWithChildren
  DashboardBannerManagementBannerIdRoute: typeof DashboardBannerManagementBannerIdRoute
  DashboardBannerManagementNewRoute: typeof DashboardBannerManagementNewRoute
  DashboardCompaniesIdRoute: typeof DashboardCompaniesIdRoute
  DashboardCompaniesAddRoute: typeof DashboardCompaniesAddRoute
  DashboardFantasyContestGroupRoute: typeof DashboardFantasyContestGroupRoute
  DashboardFantasyPlayersRoute: typeof DashboardFantasyPlayersRoute
  DashboardLeaderboardIdRoute: typeof DashboardLeaderboardIdRoute
  DashboardLeaderboardAddRoute: typeof DashboardLeaderboardAddRoute
  DashboardProductIdRoute: typeof DashboardProductIdRoute
  DashboardProductManageVoucherRoute: typeof DashboardProductManageVoucherRoute
  DashboardProductTrackOrderRoute: typeof DashboardProductTrackOrderRoute
  DashboardPromotersPromoterIdRoute: typeof DashboardPromotersPromoterIdRoute
  DashboardSupportEscalateIssueRoute: typeof DashboardSupportEscalateIssueRoute
  DashboardSupportManageUserRoute: typeof DashboardSupportManageUserRouteWithChildren
  DashboardSupportPushNotificationRoute: typeof DashboardSupportPushNotificationRoute
  DashboardAdminApprovalsIndexRoute: typeof DashboardAdminApprovalsIndexRoute
  DashboardAdminLogsIndexRoute: typeof DashboardAdminLogsIndexRoute
  DashboardBannerManagementIndexRoute: typeof DashboardBannerManagementIndexRoute
  DashboardBrandIndexRoute: typeof DashboardBrandIndexRoute
  DashboardCategoryIndexRoute: typeof DashboardCategoryIndexRoute
  DashboardCompaniesIndexRoute: typeof DashboardCompaniesIndexRoute
  DashboardFantasyIndexRoute: typeof DashboardFantasyIndexRoute
  DashboardHorizonIndexRoute: typeof DashboardHorizonIndexRoute
  DashboardLeaderboardIndexRoute: typeof DashboardLeaderboardIndexRoute
  DashboardMaintenanceIndexRoute: typeof DashboardMaintenanceIndexRoute
  DashboardMasterControlIndexRoute: typeof DashboardMasterControlIndexRoute
  DashboardProductIndexRoute: typeof DashboardProductIndexRoute
  DashboardPromotersIndexRoute: typeof DashboardPromotersIndexRoute
  DashboardFantasyContestTemplateAddTemplateRouteRoute: typeof DashboardFantasyContestTemplateAddTemplateRouteRouteWithChildren
  DashboardFantasyFixtureContestWinnerManagementV2RouteRoute: typeof DashboardFantasyFixtureContestWinnerManagementV2RouteRouteWithChildren
  DashboardBrandAddBrandAddBrandPropsRoute: typeof DashboardBrandAddBrandAddBrandPropsRoute
  DashboardCategoryAddCategoryCategoryImageRoute: typeof DashboardCategoryAddCategoryCategoryImageRoute
  DashboardFantasyContestTemplateDetailsRoute: typeof DashboardFantasyContestTemplateDetailsRoute
  DashboardFantasyFixtureChooseFromTemplateRoute: typeof DashboardFantasyFixtureChooseFromTemplateRoute
  DashboardFantasyFixtureContestCategoryRoute: typeof DashboardFantasyFixtureContestCategoryRoute
  DashboardFantasyFixtureContestTemplateDetailsRoute: typeof DashboardFantasyFixtureContestTemplateDetailsRoute
  DashboardFantasyFixtureFixtureTeamManagementRoute: typeof DashboardFantasyFixtureFixtureTeamManagementRoute
  DashboardFantasyLeagueManagementAddTourRoute: typeof DashboardFantasyLeagueManagementAddTourRoute
  DashboardHorizonTopicsIdRoute: typeof DashboardHorizonTopicsIdRoute
  DashboardLeaderboardCloneIdRoute: typeof DashboardLeaderboardCloneIdRoute
  DashboardProductComboIdRoute: typeof DashboardProductComboIdRoute
  DashboardPromotersRequestsRequestIdRoute: typeof DashboardPromotersRequestsRequestIdRoute
  DashboardPromotersVerificationVerificationIdRoute: typeof DashboardPromotersVerificationVerificationIdRoute
  DashboardPromotersWithdrawRequestWithdrawalIdRoute: typeof DashboardPromotersWithdrawRequestWithdrawalIdRoute
  DashboardBrandAddBrandIndexRoute: typeof DashboardBrandAddBrandIndexRoute
  DashboardCategoryAddCategoryIndexRoute: typeof DashboardCategoryAddCategoryIndexRoute
  DashboardFantasyContestTemplateIndexRoute: typeof DashboardFantasyContestTemplateIndexRoute
  DashboardFantasyFixtureIndexRoute: typeof DashboardFantasyFixtureIndexRoute
  DashboardFantasyHomeManagementIndexRoute: typeof DashboardFantasyHomeManagementIndexRoute
  DashboardFantasyLeagueManagementIndexRoute: typeof DashboardFantasyLeagueManagementIndexRoute
  DashboardFantasyTeamsIndexRoute: typeof DashboardFantasyTeamsIndexRoute
  DashboardHorizonCategoriesIndexRoute: typeof DashboardHorizonCategoriesIndexRoute
  DashboardHorizonEventTemplatesIndexRoute: typeof DashboardHorizonEventTemplatesIndexRoute
  DashboardHorizonTopicsIndexRoute: typeof DashboardHorizonTopicsIndexRoute
  DashboardProductAddProductIndexRoute: typeof DashboardProductAddProductIndexRoute
  DashboardProductComboIndexRoute: typeof DashboardProductComboIndexRoute
  DashboardPromotersRequestsIndexRoute: typeof DashboardPromotersRequestsIndexRoute
  DashboardPromotersVerificationIndexRoute: typeof DashboardPromotersVerificationIndexRoute
  DashboardPromotersWithdrawRequestIndexRoute: typeof DashboardPromotersWithdrawRequestIndexRoute
  DashboardFantasyFixtureContestDetailsUserPlayersRoute: typeof DashboardFantasyFixtureContestDetailsUserPlayersRoute
  DashboardFantasyFixtureContestDetailsIndexRoute: typeof DashboardFantasyFixtureContestDetailsIndexRoute
  DashboardFantasyFixtureContestWinnerManagementIndexRoute: typeof DashboardFantasyFixtureContestWinnerManagementIndexRoute
  DashboardHorizonEventTemplatesRequestsIndexRoute: typeof DashboardHorizonEventTemplatesRequestsIndexRoute
  DashboardProductAddProductSaleSettingsIndexRoute: typeof DashboardProductAddProductSaleSettingsIndexRoute
  DashboardProductComboAddCombinationIndexRoute: typeof DashboardProductComboAddCombinationIndexRoute
  DashboardProductAddProductSaleSettingsProductSettingsInvoiceDetailsRoute: typeof DashboardProductAddProductSaleSettingsProductSettingsInvoiceDetailsRoute
  DashboardProductAddProductSaleSettingsProductSettingsIndexRoute: typeof DashboardProductAddProductSaleSettingsProductSettingsIndexRoute
}

const DashboardRouteRouteChildren: DashboardRouteRouteChildren = {
  DashboardAdminActionRoute: DashboardAdminActionRoute,
  DashboardApkManagementRoute: DashboardApkManagementRoute,
  DashboardBannerRoute: DashboardBannerRoute,
  DashboardBulkOperationRoute: DashboardBulkOperationRoute,
  DashboardCancelOrderRoute: DashboardCancelOrderRoute,
  DashboardFailedOrdersRoute: DashboardFailedOrdersRoute,
  DashboardMerchandiseRoute: DashboardMerchandiseRoute,
  DashboardNovoSellRetryRoute: DashboardNovoSellRetryRoute,
  DashboardOrdersRoute: DashboardOrdersRoute,
  DashboardPromoterRoute: DashboardPromoterRoute,
  DashboardRiskCheckRoute: DashboardRiskCheckRoute,
  DashboardIndexRoute: DashboardIndexRoute,
  DashboardFantasyCreateContestRouteRoute:
    DashboardFantasyCreateContestRouteRouteWithChildren,
  DashboardBannerManagementBannerIdRoute:
    DashboardBannerManagementBannerIdRoute,
  DashboardBannerManagementNewRoute: DashboardBannerManagementNewRoute,
  DashboardCompaniesIdRoute: DashboardCompaniesIdRoute,
  DashboardCompaniesAddRoute: DashboardCompaniesAddRoute,
  DashboardFantasyContestGroupRoute: DashboardFantasyContestGroupRoute,
  DashboardFantasyPlayersRoute: DashboardFantasyPlayersRoute,
  DashboardLeaderboardIdRoute: DashboardLeaderboardIdRoute,
  DashboardLeaderboardAddRoute: DashboardLeaderboardAddRoute,
  DashboardProductIdRoute: DashboardProductIdRoute,
  DashboardProductManageVoucherRoute: DashboardProductManageVoucherRoute,
  DashboardProductTrackOrderRoute: DashboardProductTrackOrderRoute,
  DashboardPromotersPromoterIdRoute: DashboardPromotersPromoterIdRoute,
  DashboardSupportEscalateIssueRoute: DashboardSupportEscalateIssueRoute,
  DashboardSupportManageUserRoute: DashboardSupportManageUserRouteWithChildren,
  DashboardSupportPushNotificationRoute: DashboardSupportPushNotificationRoute,
  DashboardAdminApprovalsIndexRoute: DashboardAdminApprovalsIndexRoute,
  DashboardAdminLogsIndexRoute: DashboardAdminLogsIndexRoute,
  DashboardBannerManagementIndexRoute: DashboardBannerManagementIndexRoute,
  DashboardBrandIndexRoute: DashboardBrandIndexRoute,
  DashboardCategoryIndexRoute: DashboardCategoryIndexRoute,
  DashboardCompaniesIndexRoute: DashboardCompaniesIndexRoute,
  DashboardFantasyIndexRoute: DashboardFantasyIndexRoute,
  DashboardHorizonIndexRoute: DashboardHorizonIndexRoute,
  DashboardLeaderboardIndexRoute: DashboardLeaderboardIndexRoute,
  DashboardMaintenanceIndexRoute: DashboardMaintenanceIndexRoute,
  DashboardMasterControlIndexRoute: DashboardMasterControlIndexRoute,
  DashboardProductIndexRoute: DashboardProductIndexRoute,
  DashboardPromotersIndexRoute: DashboardPromotersIndexRoute,
  DashboardFantasyContestTemplateAddTemplateRouteRoute:
    DashboardFantasyContestTemplateAddTemplateRouteRouteWithChildren,
  DashboardFantasyFixtureContestWinnerManagementV2RouteRoute:
    DashboardFantasyFixtureContestWinnerManagementV2RouteRouteWithChildren,
  DashboardBrandAddBrandAddBrandPropsRoute:
    DashboardBrandAddBrandAddBrandPropsRoute,
  DashboardCategoryAddCategoryCategoryImageRoute:
    DashboardCategoryAddCategoryCategoryImageRoute,
  DashboardFantasyContestTemplateDetailsRoute:
    DashboardFantasyContestTemplateDetailsRoute,
  DashboardFantasyFixtureChooseFromTemplateRoute:
    DashboardFantasyFixtureChooseFromTemplateRoute,
  DashboardFantasyFixtureContestCategoryRoute:
    DashboardFantasyFixtureContestCategoryRoute,
  DashboardFantasyFixtureContestTemplateDetailsRoute:
    DashboardFantasyFixtureContestTemplateDetailsRoute,
  DashboardFantasyFixtureFixtureTeamManagementRoute:
    DashboardFantasyFixtureFixtureTeamManagementRoute,
  DashboardFantasyLeagueManagementAddTourRoute:
    DashboardFantasyLeagueManagementAddTourRoute,
  DashboardHorizonTopicsIdRoute: DashboardHorizonTopicsIdRoute,
  DashboardLeaderboardCloneIdRoute: DashboardLeaderboardCloneIdRoute,
  DashboardProductComboIdRoute: DashboardProductComboIdRoute,
  DashboardPromotersRequestsRequestIdRoute:
    DashboardPromotersRequestsRequestIdRoute,
  DashboardPromotersVerificationVerificationIdRoute:
    DashboardPromotersVerificationVerificationIdRoute,
  DashboardPromotersWithdrawRequestWithdrawalIdRoute:
    DashboardPromotersWithdrawRequestWithdrawalIdRoute,
  DashboardBrandAddBrandIndexRoute: DashboardBrandAddBrandIndexRoute,
  DashboardCategoryAddCategoryIndexRoute:
    DashboardCategoryAddCategoryIndexRoute,
  DashboardFantasyContestTemplateIndexRoute:
    DashboardFantasyContestTemplateIndexRoute,
  DashboardFantasyFixtureIndexRoute: DashboardFantasyFixtureIndexRoute,
  DashboardFantasyHomeManagementIndexRoute:
    DashboardFantasyHomeManagementIndexRoute,
  DashboardFantasyLeagueManagementIndexRoute:
    DashboardFantasyLeagueManagementIndexRoute,
  DashboardFantasyTeamsIndexRoute: DashboardFantasyTeamsIndexRoute,
  DashboardHorizonCategoriesIndexRoute: DashboardHorizonCategoriesIndexRoute,
  DashboardHorizonEventTemplatesIndexRoute:
    DashboardHorizonEventTemplatesIndexRoute,
  DashboardHorizonTopicsIndexRoute: DashboardHorizonTopicsIndexRoute,
  DashboardProductAddProductIndexRoute: DashboardProductAddProductIndexRoute,
  DashboardProductComboIndexRoute: DashboardProductComboIndexRoute,
  DashboardPromotersRequestsIndexRoute: DashboardPromotersRequestsIndexRoute,
  DashboardPromotersVerificationIndexRoute:
    DashboardPromotersVerificationIndexRoute,
  DashboardPromotersWithdrawRequestIndexRoute:
    DashboardPromotersWithdrawRequestIndexRoute,
  DashboardFantasyFixtureContestDetailsUserPlayersRoute:
    DashboardFantasyFixtureContestDetailsUserPlayersRoute,
  DashboardFantasyFixtureContestDetailsIndexRoute:
    DashboardFantasyFixtureContestDetailsIndexRoute,
  DashboardFantasyFixtureContestWinnerManagementIndexRoute:
    DashboardFantasyFixtureContestWinnerManagementIndexRoute,
  DashboardHorizonEventTemplatesRequestsIndexRoute:
    DashboardHorizonEventTemplatesRequestsIndexRoute,
  DashboardProductAddProductSaleSettingsIndexRoute:
    DashboardProductAddProductSaleSettingsIndexRoute,
  DashboardProductComboAddCombinationIndexRoute:
    DashboardProductComboAddCombinationIndexRoute,
  DashboardProductAddProductSaleSettingsProductSettingsInvoiceDetailsRoute:
    DashboardProductAddProductSaleSettingsProductSettingsInvoiceDetailsRoute,
  DashboardProductAddProductSaleSettingsProductSettingsIndexRoute:
    DashboardProductAddProductSaleSettingsProductSettingsIndexRoute,
}

const DashboardRouteRouteWithChildren = DashboardRouteRoute._addFileChildren(
  DashboardRouteRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  DashboardRouteRoute: DashboardRouteRouteWithChildren,
  LoginRoute: LoginRoute,
  LogoutRoute: LogoutRoute,
  AdminAuthSuccessRoute: AdminAuthSuccessRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
